/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

const digitKerning = {
  B9: -1, B10: -1, B11: -1, B12: -1, B13: -1,
  B14: -1, B15: -1, B16: -1, B17: -1, B18: -1
};

const smallDigitKerning = {
  B19: -1, B20: -1, B21: -1, B22: -1, B23: -1,
  B24: -1, B25: -1, B26: -1, B27: -1, B28: -1
};

const glyphData = {
  B1: {
    codeString: "VL6:0,8;DOT:0,16",
    shrinksPrecedingWordSpace: true
  },
  B2: {
    codeString: "C2:0,8;DL4-8N:0,8;C2:2,14",
    shrinksPrecedingWordSpace: true
  },
  B3: {
    codeString: "OC4SW:0,8;VL2:2,12;DOT:2,16",
    shrinksPrecedingWordSpace: true
  },
  B4: {
    codeString: "DOT:0,16",
    shrinksPrecedingWordSpace: true
  },
  B5: {
    codeString: "COMMA:0,16",
    shrinksPrecedingWordSpace: true
  },
  B6: {
    codeString: "DOT:0,14;DOT:0,16",
    shrinksPrecedingWordSpace: true
  },
  B7: {
    codeString: "COMMA:0,8",
    shrinksPrecedingWordSpace: true
  },
  B8: {
    codeString: "C2:0,8"
  },
  B9: {
    codeString: "HC2N:0,12;VL2:0,13;HC2S:0,15;VL2:2,13",
    kerningRules: digitKerning
  },
  B10: {
    codeString: "DL1N:0,12;VL4:1,12;HL2:0,16",
    kerningRules: digitKerning
  },
  B11: {
    codeString: "HC2N:0,12;DL2-3N:0,13;HL2:0,16",
    kerningRules: digitKerning
  },
  B12: {
    codeString: "OC2SW:0,12;OC2NW:0,14",
    kerningRules: digitKerning
  },
  B13: {
    codeString: "VL2:0,12;HL2:0,14;VL4:2,12",
    kerningRules: digitKerning
  },
  B14: {
    codeString: "HL2:0,12;VL2:0,12;HL1:0,14;HL1:0,16;HC2E:1,14",
    kerningRules: digitKerning
  },
  B15: {
    codeString: "HC2N:0,12;VL2:0,13;C2:0,14",
    kerningRules: digitKerning
  },
  B16: {
    codeString: "HL2:0,12;DL1-4N:1,12",
    kerningRules: digitKerning
  },
  B17: {
    codeString: "C2:0,12;C2:0,14",
    kerningRules: digitKerning
  },
  B18: {
    codeString: "C2:0,12;HC2S:0,15;VL2:2,13",
    kerningRules: digitKerning
  },
  B19: {
    codeString: "HC1N:0,14;VL1:0,14.5;HC1S:0,15.5;VL1:1,14.5",
    kerningRules: smallDigitKerning
  },
  B20: {
    codeString: "DL.5N:0,14;VL2:0.5,14;HL1:0,16",
    kerningRules: smallDigitKerning
  },
  B21: {
    codeString: "HC1N:0,14;DL1-1.5N:0,14.5;HL1:0,16",
    kerningRules: smallDigitKerning
  },
  B22: {
    codeString: "OC1SW:0,14;OC1NW:0,15",
    kerningRules: smallDigitKerning
  },
  B23: {
    codeString: "VL1:0,14;HL1:0,15;VL2:1,14",
    kerningRules: smallDigitKerning
  },
  B24: {
    codeString: "HL1:0,14;VL1:0,14;HL.5:0,15;HL.5:0,16;HC1E:0.5,15",
    kerningRules: smallDigitKerning
  },
  B25: {
    codeString: "HC1N:0,14;VL1:0,14.5;C1:0,15",
    kerningRules: smallDigitKerning
  },
  B26: {
    codeString: "HL1:0,14;DL.5-2N:0.5,14",
    kerningRules: smallDigitKerning
  },
  B27: {
    codeString: "C1:0,14;C1:0,15",
    kerningRules: smallDigitKerning
  },
  B28: {
    codeString: "C1:0,14;HC1S:0,15.5;VL1:1,14.5",
    kerningRules: smallDigitKerning
  },
  B81: {
    codeString: "AA2N:0,4",
    isIndicator: true,
    indicatorRole: 'verbal',
    name: "INDICATOR ACTION"
  },
  B82: {
    codeString: "AA2E:0,4",
    isIndicator: true,
    indicatorRole: 'verbal',
    name: "INDICATOR ACTIVE"
  },
  B83: {
    codeString: "OC1SW:0,4;VL.25:0.5,5;DOT:0.5,6",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 1,
    name: "INDICATOR PRESENT CONDITIONAL"
  },
  B84: {
    codeString: "B86;B270:3,-8",
    isIndicator: true,
    indicatorRole: 'adjectival',
    anchorOffsetX: -0.5,
    width: 3,
    name: "INDICATOR DESCRIPTION AFTER THE FACT"
  },
  B85: {
    codeString: "B270:0,-8;B86:1,0",
    isIndicator: true,
    indicatorRole: 'adjectival',
    anchorOffsetX:  0.5,
    width: 3,
    name: "INDICATOR DESCRIPTION BEFORE THE FACT"
  },
  B86: {
    codeString: "AA2S:0,4",
    isIndicator: true,
    indicatorRole: 'adjectival',
    name: "INDICATOR DESCRIPTION"
  },
  B87: {
    codeString: "HW2W:0,4",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 0.5,
    name: "INDICATOR FUTURE"
  },
  B88: {
    codeString: "B83;B87:2,0",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 2.5,
    name: "INDICATOR FUTURE CONDITIONAL"
  },
  B89: {
    codeString: "B91;B87:3,0",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 3.5,
    name: "INDICATOR FUTURE PASSIVE"
  },
  B90: {
    codeString: "B91;B88:3,0",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 5.5,
    name: "INDICATOR FUTURE PASSIVE CONDITIONAL"
  },
  B91: {
    codeString: "AA2W:0,4",
    isIndicator: true,
    indicatorRole: 'verbal',
    name: "INDICATOR PASSIVE"
  },
  B92: {
    codeString: "HW2E:0,4",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 0.5,
    name: "INDICATOR PAST"
  },
  B93: {
    codeString: "B83;B92:2,0",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 2.5,
    name: "INDICATOR PAST CONDITIONAL"
  },
  B94: {
    codeString: "B91;B93:3,0",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 5.5,
    name: "INDICATOR PAST PASSIVE CONDITIONAL"
  },
  B95: {
    codeString: "B91;B92:3,0",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 3.5,
    name: "INDICATOR PAST PASSIVE"
  },
  B96: {
    codeString: "B91;B83:3,0",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 4,
    name: "INDICATOR PRESENT PASSIVE CONDITIONAL"
  },
  B97: {
    codeString: "S2:0,4",
    isIndicator: true,
    semanticIndicator: 'thing',
    indicatorRole: 'nominal',
    name: "INDICATOR THING"
  },
  B98: {
    codeString: "B97;B99:3,0",
    isIndicator: true,
    semanticIndicator: 'thing',
    indicatorRole: 'nominal',
    width: 5,
    name: "INDICATOR PLURAL THING"
  },
  B99: {
    codeString: "DC2:0,4",
    isIndicator: true,
    indicatorRole: 'nominal',
    name: "INDICATOR PLURAL"
  },
  B100: {
    codeString: "DL2S:0,11"
  },
  B101: {
    codeString: "B270;B297:2,0",
    anchorOffsetX: 1
  },
  B102: {
    codeString: "RA4E:0,10"
  },
  B103: {
    codeString: "B239;VL6:2,8;HL4:2,8;VL6:6,8"
  },
  B104: {
    codeString: "VL6:2,10;HL4:0,12;HL4:0,14"
  },
  B105: {
    codeString: "AA8N:0,8"
  },
  B106: {
    codeString: "AA4N:0,12"
  },
  B107: {
    codeString: "SC8:0,8"
  },
  B108: {
    codeString: "B325;HL4:0,8;HL4:0,16"
  },
  B109: {
    codeString: "B428;B270:2,0",
    anchorOffsetX: -1
  },
  B110: {
    codeString: "B270;B270:2,0"
  },
  B111: {
    codeString: "RA4W:0,10;RA4W:2,10"
  },
  B112: {
    codeString: "HW4E:0,12"
  },
  B113: {
    codeString: "B335;B335:0,4"
  },
  B114: {
    codeString: "B597;B473:4,0"
  },
  B115: {
    codeString: "B708;B700:2,0"
  },
  B116: {
    codeString: "RA8S:0,8;VL4:4,12;HL8:0,16"
  },
  B117: {
    codeString: "B291;B459"
  },
  B118: {
    codeString: "Xa;Xb:3.2354,0;Xc:6.4708,0"
  },
  B119: {
    codeString: "P4W:0,6;P4E:4,10;P4W:0,14",
    anchorOffsetY: -2
  },
  B120: {
    codeString: "SC4:0,10"
  },
  B121: {
    codeString: "DL8N:0,8;HL8:0,16"
  },
  B122: {
    codeString: "HL8:0,12;AA4N:0,12;AA4N:4,12"
  },
  B123: {
    codeString: "B122;B737:4,2"
  },
  B124: {
    codeString: "HC4W:0,8;B122:2,0",
    anchorOffsetX: 1
  },
  B125: {
    codeString: "B122;B737:4,0"
  },
  B126: {
    codeString: "B122;HC2N:0,15;HC2N:4,15;HC2N:8,15",
    anchorOffsetX: -1
  },
  B127: {
    codeString: "B122;B695:0,6"
  },
  B128: {
    codeString: "P4E:0,14;B514:3,0",
    anchorOffsetX: 1.5
  },
  B129: {
    codeString: "B291;B699:3,0"
  },
  B130: {
    codeString: "B281;B100:3,0"
  },
  B131: {
    codeString: "HC4N:0,10;HC4N:4,10;HC8S:0,12;QC4NW:4,8"
  },
  B132: {
    codeString: "RA4SW:0,8"
  },
  B133: {
    codeString: "B212;HL4:0,10;VL2:4,10"
  },
  B134: {
    codeString: "B255;B270"
  },
  B135: {
    codeString: "RA4E:0,10;B270:4,0",
    anchorOffsetX: -1
  },
  B136: {
    codeString: "LARRC8SC:0,8;B5840:3,0"
  },
  B137: {
    codeString: "B257;B11:7,0;B500:8,0"
  },
  B138: {
    codeString: "QC4NW:3,4;VQW4NW:1,8;VQW4NE:3,8;HW4W:0,12;HW4E:5,12;B528:2.5,0;HL4:1,16",
    anchorOffsetX: -0.5,
    anchorOffsetY: -4
  },
  B139: {
    codeString: "VL4:0,10;P4E:8,10",
    anchorOffsetX: -1
  },
  B140: {
    codeString: "C4:0,12;VL4:4,12;HL4:4,14;VL4:8,12"
  },
  B141: {
    codeString: "C4:0,12;AA4W:4,12"
  },
  B142: {
    codeString: "C4:0,12;AT4W:4,12"
  },
  B143: {
    codeString: "P4E:0,6;B518:3,0",
    anchorOffsetX: 1.5,
    anchorOffsetY: -1
  },
  B144: {
    codeString: "B335;B145:0,4"
  },
  B145: {
    codeString: "LARR8W:0,10"
  },
  B146: {
    codeString: "VL4:0,8;HL8:0,8;VL4:8,8;HC8S:0,12"
  },
  B147: {
    codeString: "HC4N:2,10;R84:0,12"
  },
  B148: {
    codeString: "C4:0,12;HL4:0,14"
  },
  B149: {
    codeString: "C8:0,4;QC4SE:0,12",
    anchorOffsetY: -4
  },
  B150: {
    codeString: "QC4NW:0,4;HW8E:0,8;HC8E:0,8",
    anchorOffsetY: -4
  },
  B151: {
    codeString: "B612;B428:12,0"
  },
  B152: {
    codeString: "B122;B708"
  },
  B153: {
    codeString: "B281;B695:8,4"
  },
  B154: {
    codeString: "B801;C4:1,10"
  },
  B155: {
    codeString: "B1139;P4W:7,16",
    anchorOffsetX: -0.5
  },
  B156: {
    codeString: "VL8:0,8;HL8:0,12;DL4N:4,8;VL8:8,8"
  },
  B157: {
    codeString: "B400;HC8N:2,8;HL8:2,12"
  },
  B158: {
    codeString: "B270;B428:2,0",
    anchorOffsetX: 1
  },
  B159: {
    codeString: "B428;B335"
  },
  B160: {
    codeString: "B120:0,4"
  },
  B161: {
    codeString: "C4:0,10;QC4NE:4,12",
    anchorOffsetX: -2
  },
  B162: {
    codeString: "B428;B270:2,0;B428:4,0"
  },
  B163: {
    codeString: "B708;AA2N:3,12"
  },
  B164: {
    codeString: "B163;B695:0,6"
  },
  B165: {
    codeString: "HW8W:0,8;HL8:2,8;HL2:2,16;HL2:8,16;HW8E:10,8;B140:2,-2;LARR4S:4,16"
  },
  B166: {
    codeString: "B548;B622:3,0"
  },
  B167: {
    codeString: "B712;B509"
  },
  B168: {
    codeString: "S4:0,10;DL2N:0,8;HL4:2,8;DL2N:4,8;VL4:6,8;DL2N:4,12"
  },
  B169: {
    codeString: "B639;P4N:2,13"
  },
  B170: {
    codeString: "VL4:4,8;HL8:0,12;B239"
  },
  B171: {
    codeString: "HW8W:0,8;HL8:2,8;HL8:2,16;HW8E:10,8"
  },
  B172: {
    codeString: "DOT:0,8;VL4:0,10;DOT:0,16"
  },
  B173: {
    codeString: "B497;OR48W:4,8"
  },
  B174: {
    codeString: "VL4:2,8;C4:0,12"
  },
  B175: {
    codeString: "B291;P4N:2,17"
  },
  B176: {
    codeString: "C4:0,10;C4:4,10;RA4N:2,14"
  },
  B177: {
    codeString: "S8:0,8;DL4N:0,4;HL8:4,4;DL4N:8,4;VL8:12,4;DL4N:8,12",
    anchorOffsetY: -4
  },
  B178: {
    codeString: "C4:0,8;B106"
  },
  B179: {
    codeString: "B666;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B180: {
    codeString: "HW4W:0,12;HL8:1,12;HL8:1,16;HW4E:9,12"
  },
  B181: {
    codeString: "B171;P4N:2,12;P4N:6,12"
  },
  B182: {
    codeString: "B1154;HC8N:4,12;B1154:12,0"
  },
  B183: {
    codeString: "OR84S:0,12;VL8:4,8"
  },
  B184: {
    codeString: "OR84N:0,8;VL8:4,8"
  },
  B185: {
    codeString: "B345;P4W:5,10",
    anchorOffsetX: -1.5
  },
  B186: {
    codeString: "B123;HC4N:0,10"
  },
  B187: {
    codeString: "B1137;P4W:7,16",
    anchorOffsetX: -0.5
  },
  B188: {
    codeString: "B892;DL2N:9,9;DL2S:10,10"
  },
  B189: {
    codeString: "B884;B188:10,0;HL10:12,16"
  },
  B190: {
    codeString: "QC4SE:0,10;VL6:4,10;QC4SW:4,10"
  },
  B191: {
    codeString: "B451:2,0;B239"
  },
  B192: {
    codeString: "HL4:0,12;VL4:4,10"
  },
  B193: {
    codeString: "HW8W:0,8;HW8E:2,8;HW8W:4,8;HW8E:6,8"
  },
  B194: {
    codeString: "P4E:0,10;B518:3,0",
    anchorOffsetX: 1.5
  },
  B195: {
    codeString: "RA4W:0,10"
  },
  B196: {
    codeString: "B422;HC4N:2,10"
  },
  B197: {
    codeString: "B391;HC4N:0,10;HC4N:4,10",
    anchorOffsetX: -3
  },
  B198: {
    codeString: "B291;B424"
  },
  B199: {
    codeString: "VL4:0,8;B688;RA8N:0,4;VL4:8,8",
    anchorOffsetY: -4
  },
  B200: {
    codeString: "C4:0,8;VL4:0,10;VL4:4,10;HC4S:0,14"
  },
  B201: {
    codeString: "B700:3,0;B939",
    anchorOffsetX: 1
  },
  B202: {
    codeString: "B688;DL2N:5,9;DL2S:6,10"
  },
  B203: {
    codeString: "QC4NW:4,12;B281;AA4S:2,16"
  },
  B204: {
    codeString: "B1099;LARR4E:4,8",
    anchorOffsetX: -2
  },
  B205: {
    codeString: "HL14:0,8;VL8:0,8;C4:2,10;HL6:4,10;C4:8,10;VL8:14,8;HL14:0,16"
  },
  B206: {
    codeString: "RT8E:0,8"
  },
  B207: {
    codeString: "B644;DOT:2,14"
  },
  B208: {
    codeString: "B572;P4N:2,9"
  },
  B209: {
    codeString: "B1119;VL6:2,8;VL8:4,8;VL6:6,8;HC4S:2,14"
  },
  B210: {
    codeString: "HC4N:0,10;VL2:0,12;HC4S:0,14;VL10:2,8"
  },
  B211: {
    codeString: "B265;B357:6,0"
  },
  B212: {
    codeString: "VL8:0,8;HL4:0,12;VL4:4,12"
  },
  B213: {
    codeString: "B423;B695"
  },
  B214: {
    codeString: "B306;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B215: {
    codeString: "RA4NE:0,12;QC4SW:0,12"
  },
  B216: {
    codeString: "DL8N:0,8;VL4:8,8;B651:6,2",
    anchorOffsetX: 3
  },
  B217: {
    codeString: "B338;B528:1.5,0;HW4W:5,8;C4:4,12;B528:5.5,0"
  },
  B218: {
    codeString: "B171;P4N:4,12"
  },
  B219: {
    codeString: "S8:0,8;HL8:0,12;DOT:4,10;DOT:4,14"
  },
  B220: {
    codeString: "C4:0,8;B956"
  },
  B221: {
    codeString: "B1132;P4W:9,6",
    anchorOffsetX: -1.5
  },
  B222: {
    codeString: "B306;P4N:2,17"
  },
  B223: {
    codeString: "B368:0,-4;HL4:0,12;B303:0,2"
  },
  B224: {
    codeString: "B1085;P4N:4,17"
  },
  B225: {
    codeString: "B281;B433:2,0"
  },
  B226: {
    codeString: "B126;P4W:11,14",
    anchorOffsetX: -2.5
  },
  B227: {
    codeString: "B978;P4W:8,12",
    anchorOffsetX: -1
  },
  B228: {
    codeString: "VL8:2,8;VL8:6,8;HL8:0,10;HL8:0,14"
  },
  B229: {
    codeString: "B228;B548"
  },
  B230: {
    codeString: "B597;W8N:0,7",
    anchorOffsetY: -1
  },
  B231: {
    codeString: "OR84N:0,12;VL4:4,12"
  },
  B232: {
    codeString: "C4:0,10;C4:2,10"
  },
  B233: {
    codeString: "C2:0,4;C2:1,4",
    anchorOffsetY: -4
  },
  B234: {
    codeString: "B622:0,4;B255:1,0"
  },
  B235: {
    codeString: "HC4N:0,8;HC4N:4,8;VL6:0,10;VL6:4,10;VL6:8,10;HL8:0,16"
  },
  B236: {
    codeString: "W8S:0,11;B285:6,0",
    anchorOffsetX: 3
  },
  B237: {
    codeString: "RA8N:0,8;HC8S:0,12"
  },
  B238: {
    codeString: "B447;B447:0,-4",
    anchorOffsetY: -4
  },
  B239: {
    codeString: "HC8S:0,12"
  },
  B240: {
    codeString: "B687;DOT:4,10;DOT:4,12;DOT:4,14"
  },
  B241: {
    codeString: "B572;P4W:9,14",
    anchorOffsetX: -1.5
  },
  B242: {
    codeString: "DL4S:0,8;OR84S:4,12"
  },
  B243: {
    codeString: "B281;B322:4,0"
  },
  B244: {
    codeString: "B281;B666"
  },
  B245: {
    codeString: "B433;B710:4,0"
  },
  B246: {
    codeString: "B433;B548:2,0;B710:8,0"
  },
  B247: {
    codeString: "AT8N:0,8"
  },
  B248: {
    codeString: "VL8:2,8;HL4:0,10"
  },
  B249: {
    codeString: "B171;P4N:4,17"
  },
  B250: {
    codeString: "RA4N:0,8;B651;RA4S:0,14"
  },
  B251: {
    codeString: "B352;HC4E:4,10",
    anchorOffsetX: -1
  },
  B252: {
    codeString: "S8:0,8;DOT:2,12;VL8:4,8;DOT:6,12"
  },
  B253: {
    codeString: "B161;C4:0,14;HW4N:4,15",
    anchorOffsetX: -2
  },
  B254: {
    codeString: "OS8S:0,8;QC4SE:0,8;QC4SW:4,8"
  },
  B255: {
    codeString: "HC8E:0,8"
  },
  B256: {
    codeString: "B247;B401:4,0"
  },
  B257: {
    codeString: "B548;B314:2,0"
  },
  B258: {
    codeString: "B281;B636"
  },
  B259: {
    codeString: "B423;B939"
  },
  B260: {
    codeString: "B447;B292"
  },
  B261: {
    codeString: "B213;LARR8E:8,10",
    anchorOffsetX: -4
  },
  B262: {
    codeString: "B939;B578:2,0"
  },
  B263: {
    codeString: "C4:0,12;HW4E:5,12"
  },
  B264: {
    codeString: "B939;B562"
  },
  B265: {
    codeString: "DL4S:0,12;HL8:4,16;DL4N:12,12"
  },
  B266: {
    codeString: "DOT:4,10;HL8:0,12;DOT:4,14"
  },
  B267: {
    codeString: "VL12:2,6;OC4SE:0,8;OC4NW:0,12",
    anchorOffsetY: -2
  },
  B268: {
    codeString: "HC4E:0,14;B851:2,0",
    anchorOffsetX: 1
  },
  B269: {
    codeString: "OS8S:0,8"
  },
  B270: {
    codeString: "DOT:0,12"
  },
  B271: {
    codeString: "LARR8S:0,8"
  },
  B272: {
    codeString: "RA4SW:0,12;DL8N:0,8"
  },
  B273: {
    codeString: "DL8S:0,8;RA4SE:4,12"
  },
  B274: {
    codeString: "B219;P4W:9,8",
    anchorOffsetX: -1.5
  },
  B275: {
    codeString: "B695;B329:2,0"
  },
  B276: {
    codeString: "B391;HC4N:2,10",
    anchorOffsetX: -3
  },
  B277: {
    codeString: "B426;B270:4,-6",
    anchorOffsetY: -2
  },
  B278: {
    codeString: "E:0,8"
  },
  B279: {
    codeString: "B651;B278:2,0"
  },
  B280: {
    codeString: "DL8S:0,8;C8:0,8"
  },
  B281: {
    codeString: "HL8:0,16"
  },
  B282: {
    codeString: "B636;P4E:5,10"
  },
  B283: {
    codeString: "B639;P4S:6,9"
  },
  B284: {
    codeString: "B559;OR48W:0,8"
  },
  B285: {
    codeString: "C8:0,8;HW4N:2,11;HW4S:2,12"
  },
  B286: {
    codeString: "B270;RA4E:0,10"
  },
  B287: {
    codeString: "P4E:0,10;B132:3,0",
    anchorOffsetX: 1.5
  },
  B288: {
    codeString: "DL4N:0,8;HL4:0,12;DL4N:0,12"
  },
  B289: {
    codeString: "DL8-4S:0,10;VL4:8,10;DL8-4S:8,10"
  },
  B290: {
    codeString: "B171;B894:4,0"
  },
  B291: {
    codeString: "S8:0,8"
  },
  B292: {
    codeString: "B335;B428:8,0"
  },
  B293: {
    codeString: "B289;B636:4,0"
  },
  B294: {
    codeString: "B712;B695"
  },
  B295: {
    codeString: "B518;DL2N:0,10"
  },
  B296: {
    codeString: "VL2:2,6;HW8W:0,8;HW8E:2,8",
    anchorOffsetY: -2
  },
  B297: {
    codeString: "AA8S:0,8"
  },
  B298: {
    codeString: "B281;VQW4NE:4,12;QC4NE:4,12"
  },
  B299: {
    codeString: "B894;B1154"
  },
  B300: {
    codeString: "B666;QC4SE:0,10;QC4SW:4,10"
  },
  B301: {
    codeString: "B447;B1042:2,0"
  },
  B302: {
    codeString: "LARR4W:0,10;LARR4N:4,6;B651:4,0;LARR4E:8,10;LARR4S:4,14",
    anchorOffsetY: -2
  },
  B303: {
    codeString: "C4:0,10;DOT:2,12"
  },
  B304: {
    codeString: "B1138;P4W:5,6",
    anchorOffsetX: -1.5,
    anchorOffsetY: -2
  },
  B305: {
    codeString: "B303;P4S:0,7",
    anchorOffsetY: -1
  },
  B306: {
    codeString: "B376;DOT:2,10;DOT:6,10"
  },
  B307: {
    codeString: "B447;B299:2,0"
  },
  B308: {
    codeString: "B393;B704:10,0"
  },
  B309: {
    codeString: "B513;B548:2,0;B513:8,0"
  },
  B310: {
    codeString: "HC8N:0,8;RA8S:0,12"
  },
  B311: {
    codeString: "B548;B317"
  },
  B312: {
    codeString: "B548;B433:2,0"
  },
  B313: {
    codeString: "H:0,8"
  },
  B314: {
    codeString: "AT4N:0,12"
  },
  B315: {
    codeString: "B1135;P4W:17,12",
    anchorOffsetX: -1.5
  },
  B316: {
    codeString: "B171;B140:2,-2"
  },
  B317: {
    codeString: "B357;B281"
  },
  B318: {
    codeString: "B374;P4W:5,6",
    anchorOffsetX: -1.5,
    anchorOffsetY: -1
  },
  B319: {
    codeString: "W8E:0,8"
  },
  B320: {
    codeString: "B484;B319:3,0"
  },
  B321: {
    codeString: "HC8S:0,12;HC8N:0,12"
  },
  B322: {
    codeString: "VL8:0,8;OS4W:0,8"
  },
  B323: {
    codeString: "B572;P4N:2,17"
  },
  B324: {
    codeString: "B572;P4S:2,13"
  },
  B325: {
    codeString: "C4:0,8;VL4:2,12"
  },
  B326: {
    codeString: "B1137;P4W:7,8",
    anchorOffsetX: -0.5
  },
  B327: {
    codeString: "B400;B708:2,0"
  },
  B328: {
    codeString: "B597;B695"
  },
  B329: {
    codeString: "B457;B1154"
  },
  B330: {
    codeString: "B418;P4S:8,13",
    anchorOffsetX: -2
  },
  B331: {
    codeString: "P4N:0,8;P4S:0,14"
  },
  B332: {
    codeString: "RA4E:0,10;RA4E:2,10"
  },
  B333: {
    codeString: "B306;P4S:2,7",
    anchorOffsetY: -1
  },
  B334: {
    codeString: "DL6N:0,10;DL4S:2,10;DL2N:2,8;DL2N:6,12"
  },
  B335: {
    codeString: "LARR8E:0,10"
  },
  B336: {
    codeString: "B484;B313"
  },
  B337: {
    codeString: "VL4:0,10;P4E:2,10"
  },
  B338: {
    codeString: "QC4NW:2,8;C4:0,12",
    anchorOffsetX: -1
  },
  B339: {
    codeString: "B293;B291:4,0"
  },
  B340: {
    codeString: "B1141;P4W:7,8",
    anchorOffsetX: -0.5
  },
  B341: {
    codeString: "HW8W:0,8"
  },
  B342: {
    codeString: "B392;B700;B700:4,0"
  },
  B343: {
    codeString: "B239;B694"
  },
  B344: {
    codeString: "B281;B325:2,0"
  },
  B345: {
    codeString: "B678;C4:0,10"
  },
  B346: {
    codeString: "LARR4E:0,10;LARR4S:4,6;LARR4N:4,14;LARR4W:8,10",
    anchorOffsetY: -2
  },
  B347: {
    codeString: "B106;B314:4,0"
  },
  B348: {
    codeString: "B368;B457:0,-2"
  },
  B349: {
    codeString: "B518;P4W:1,10"
  },
  B350: {
    codeString: "B122;VL8:8,4;HL4:8,4",
    anchorOffsetX: -2,
    anchorOffsetY: -4
  },
  B351: {
    codeString: "C4:0,8;B314"
  },
  B352: {
    codeString: "OR48N:0,8"
  },
  B353: {
    codeString: "B303;HC4N:4,10;B303:8,0"
  },
  B354: {
    codeString: "OS8S:0,8;B148:2,0"
  },
  B355: {
    codeString: "AA8N:0,4;HL2:0,12;HL2:6,12;B247",
    anchorOffsetY: -4
  },
  B356: {
    codeString: "B239;B651:2,0"
  },
  B357: {
    codeString: "B366;B366:4,0"
  },
  B358: {
    codeString: "B312;B500:8,0"
  },
  B359: {
    codeString: "B312;B455:8,0"
  },
  B360: {
    codeString: "B312;B312:8,0"
  },
  B361: {
    codeString: "B455;B500:8,0"
  },
  B362: {
    codeString: "B455;B455:8,0"
  },
  B363: {
    codeString: "B455;B312:8,0"
  },
  B364: {
    codeString: "B500;B500:8,0"
  },
  B365: {
    codeString: "C4:0,10;C4:4,10;C4:2,14;QC4NW:4,8"
  },
  B366: {
    codeString: "QC4NW:0,12"
  },
  B367: {
    codeString: "B281;HL8:0,20;VL2:8,18"
  },
  B368: {
    codeString: "DC4:0,12"
  },
  B369: {
    codeString: "HL12:0,12;HC4S:1,12"
  },
  B370: {
    codeString: "B394;B271:2,0"
  },
  B371: {
    codeString: "HW2W:0,10;HW2W:2,10;HW2W:4,10"
  },
  B372: {
    codeString: "B1143;P4W:7,4",
    anchorOffsetX: -0.5,
    anchorOffsetY: -3
  },
  B373: {
    codeString: "DL6N:0,10;DL4S:4,8"
  },
  B374: {
    codeString: "DL4S:0,12;VL8:4,8"
  },
  B375: {
    codeString: "B239;HL8:0,12;HC4N:2,10"
  },
  B376: {
    codeString: "C8:0,8;VL4:4,10;HL4:2,14"
  },
  B377: {
    codeString: "B132;VL8:4,8"
  },
  B378: {
    codeString: "P4W:0,10;B319:3,0;P4E:6,10"
  },
  B379: {
    codeString: "B122:4,0;DL4S:0,8;DL4S:4,8;DL4S:8,8",
    anchorOffsetX: 2
  },
  B380: {
    codeString: "P4E:0,14;B418:3,0",
    anchorOffsetX: -0.5
  },
  B381: {
    codeString: "B983;B700:2,0"
  },
  B382: {
    codeString: "DL4-8N:0,8;B513:2,0",
    anchorOffsetX: 1
  },
  B383: {
    codeString: "RA4E:0,10;B270:4,0;B270:6,0",
    anchorOffsetX: 2
  },
  B384: {
    codeString: "B418;P4W:5,6",
    anchorOffsetX: -2,
    anchorOffsetY: -2
  },
  B385: {
    codeString: "B127;DL4N:8,8;DL2S:12,8",
    anchorOffsetX: -3
  },
  B386: {
    codeString: "B1154;B239:4,4;B1154:12,0"
  },
  B387: {
    codeString: "HL8:0,12;RA4S:8,12"
  },
  B388: {
    codeString: "B454;P4W:9,14",
    anchorOffsetX: -1.5
  },
  B389: {
    codeString: "HL8:0,12;HC4N:4,10;QC4SE:8,8;QC4NE:8,12"
  },
  B390: {
    codeString: "B123;P4W:9,8",
    anchorOffsetX: -1.5
  },
  B391: {
    codeString: "B122;DL4N:8,8;DL2S:12,8",
    anchorOffsetX: -3
  },
  B392: {
    codeString: "B878;B548"
  },
  B393: {
    codeString: "B433;B548:2,0",
    anchorOffsetX: 1
  },
  B394: {
    codeString: "B695;B651:2,0"
  },
  B395: {
    codeString: "AT4S:0,12;HC4N:0,10"
  },
  B396: {
    codeString: "B418;QC4SE:0,16;QC4SE:8,16",
    anchorOffsetX: -2
  },
  B397: {
    codeString: "B447;B271:2,0"
  },
  B398: {
    codeString: "B291;B270:4,0"
  },
  B399: {
    codeString: "VL4:0,10;HL4:0,12;R84:4,10;HL4:12,12"
  },
  B400: {
    codeString: "AA4N:0,12;AA4N:4,12;AA4N:8,12"
  },
  B401: {
    codeString: "VL3:0,10;DOT:0,14"
  },
  B402: {
    codeString: "B335;B291:4,0",
    anchorOffsetX: 2
  },
  B403: {
    codeString: "QC4NW:0,12;HC4N:4,10;HL4:4,12;VL4:8,12;HL8:0,16"
  },
  B404: {
    codeString: "B695:0,4;B281:8,0;B695:16,4"
  },
  B405: {
    codeString: "VL4:0,12"
  },
  B406: {
    codeString: "P4E:0,14;B1002:3,0",
    anchorOffsetX: 1.5
  },
  B407: {
    codeString: "HL8:0,12;HC4S:0,12;VL4:8,12"
  },
  B408: {
    codeString: "B457;B457:4,0"
  },
  B409: {
    codeString: "DS8:0,4;QC4SE:0,12",
    anchorOffsetY: -4
  },
  B410: {
    codeString: "B514;P4W:5,14",
    anchorOffsetX: -1.5
  },
  B411: {
    codeString: "DL4S:0,12;DL8N:0,8"
  },
  B412: {
    codeString: "B447;OR84N:0,12"
  },
  B413: {
    codeString: "VL8:0,8;HL4:0,10;HL4:0,14;VL8:4,8"
  },
  B414: {
    codeString: "B457;B278:2,0"
  },
  B415: {
    codeString: "B281;B366:4,0"
  },
  B416: {
    codeString: "HW8W:0,8;VL8:2,8;HW8E:2,8"
  },
  B417: {
    codeString: "B418;P4W:7,10",
    anchorOffsetX: -2
  },
  B418: {
    codeString: "AA8N:0,8;HL4:0,16;HL4:8,16",
    anchorOffsetX: -2
  },
  B419: {
    codeString: "QC4NW:2,4;HW8W:0,8;HW8E:2,8",
    anchorOffsetX: -1,
    anchorOffsetY: -4
  },
  B420: {
    codeString: "VL4:0,10;HL8:0,12;VL4:8,10"
  },
  B421: {
    codeString: "B291;RA8S:0,8"
  },
  B422: {
    codeString: "B281;QC4NE:0,12;B366:4,0"
  },
  B423: {
    codeString: "B636;VL8:4,8"
  },
  B424: {
    codeString: "B636;B303:2,0"
  },
  B425: {
    codeString: "B597;B288:4,0"
  },
  B426: {
    codeString: "VL8:0,8;B655;VL8:8,8"
  },
  B427: {
    codeString: "B428;B428:8,0"
  },
  B428: {
    codeString: "VL8:0,8"
  },
  B429: {
    codeString: "P4S:0,7;B457;P4N:0,15",
    anchorOffsetY: -1
  },
  B430: {
    codeString: "B818;HC4E:0,8;HC4W:6,8"
  },
  B431: {
    codeString: "HL4:0,12;B313:4,0;B335:8,0"
  },
  B432: {
    codeString: "B636;B700:2,0"
  },
  B433: {
    codeString: "VL4:2,8;B106"
  },
  B434: {
    codeString: "B518;DL2S:0,12"
  },
  B435: {
    codeString: "W8E:0,8;QC4NW:1,4;B528:1.5,0;HC8E:1,8"
  },
  B436: {
    codeString: "HL2:0,10;RA4N:2,8;HL2:6,10;RA4E:0,10;RA4W:6,10;HL8:0,14;VL2:4,14"
  },
  B437: {
    codeString: "B548;B232:1,2"
  },
  B438: {
    codeString: "B651;B1154"
  },
  B439: {
    codeString: "B580;B829:3,0"
  },
  B440: {
    codeString: "B509;B447;B457:2,0"
  },
  B441: {
    codeString: "B420;VL4:4,10"
  },
  B442: {
    codeString: "C8:0,8;C4:2,10;QC4NW:4,4",
    anchorOffsetY: -4
  },
  B443: {
    codeString: "VL4:0,8;VL4:2,8;VL4:4,8;VL4:6,8;VL10:8,6;VL4:10,8;VL4:12,8;VL4:14,8;VL4:16,8;HL16:0,12;HL4:6,16",
    anchorOffsetY: -2
  },
  B444: {
    codeString: "B457:0,-6;VL8:2,8;B1154",
    anchorOffsetY: -4
  },
  B445: {
    codeString: "B289;B291:4,0"
  },
  B446: {
    codeString: "B291;P4S:2,10"
  },
  B447: {
    codeString: "HC8N:0,8"
  },
  B448: {
    codeString: "B456;B270:6,2"
  },
  B449: {
    codeString: "HL4:0,12"
  },
  B450: {
    codeString: "DL4S:0,8;ARR4SW:0,12"
  },
  B451: {
    codeString: "C4:0,8;C4:0,12;VL8:2,8"
  },
  B452: {
    codeString: "VL8:0,8;HC8E:0,8"
  },
  B453: {
    codeString: "HW8E:0,8;HC8E:0,8"
  },
  B454: {
    codeString: "HC8N:0,12;B281"
  },
  B455: {
    codeString: "B548;B710:2,0"
  },
  B456: {
    codeString: "RT8SE:0,8"
  },
  B457: {
    codeString: "C4:0,10"
  },
  B458: {
    codeString: "B695:0,4;HL12:0,16"
  },
  B459: {
    codeString: "DC8:0,8"
  },
  B460: {
    codeString: "B718;P4W:5,10",
    anchorOffsetX: -1.5
  },
  B461: {
    codeString: "HC4N:0,10;HL4:0,12;VL4:2,12"
  },
  B462: {
    codeString: "VL6:4,8;C4:0,12"
  },
  B463: {
    codeString: "HL4:0,8;VL8:2,8"
  },
  B464: {
    codeString: "B509;B457:2,0"
  },
  B465: {
    codeString: "B1142;P4W:6,16"
  },
  B466: {
    codeString: "B171;P4S:4,5",
    anchorOffsetY: -3
  },
  B467: {
    codeString: "HL4:0,16;DL4-8N:2,8",
    anchorOffsetX: -1
  },
  B468: {
    codeString: "VL8:0,8;HC4E:0,8"
  },
  B469: {
    codeString: "B303;B278:2,0"
  },
  B470: {
    codeString: "B281;B453:4,0"
  },
  B471: {
    codeString: "B440;B939"
  },
  B472: {
    codeString: "B636;P4N:2,9"
  },
  B473: {
    codeString: "DL4-8N:0,8;HL4:0,16"
  },
  B474: {
    codeString: "B112;B648:3,0"
  },
  B475: {
    codeString: "B449:2,0;B281"
  },
  B476: {
    codeString: "P4W:0,10;B477:3,0;P4E:12,10"
  },
  B477: {
    codeString: "B136;P2E:1,11"
  },
  B478: {
    codeString: "DL4-8N:1,8;HL8:2,10;DL4-8N:5,8;HL8:0,14"
  },
  B479: {
    codeString: "B548;B347"
  },
  B480: {
    codeString: "B695;B695:0,4"
  },
  B481: {
    codeString: "QC4NW:1,8;HW4W:0,12;HW4E:1,12",
    anchorOffsetX: -1.5
  },
  B482: {
    codeString: "B1154;P4S:0,14"
  },
  B483: {
    codeString: "B281;C4:2,16;HW4W:3,16;HW4E:4,16"
  },
  B484: {
    codeString: "OS8N:0,8"
  },
  B485: {
    codeString: "B447;B457:2,0"
  },
  B486: {
    codeString: "DL2N:0,8;VL8:2,8;DL2N:2,14"
  },
  B487: {
    codeString: "B558;B558:4,0"
  },
  B488: {
    codeString: "RA4W:0,10;B270:2,0"
  },
  B489: {
    codeString: "B338;HW4W:1,12;HW4E:2,12",
    anchorOffsetX: -1
  },
  B490: {
    codeString: "B291;B270:10,0",
    anchorOffsetX: -1
  },
  B491: {
    codeString: "B291;B335:4,0",
    anchorOffsetX: -2
  },
  B492: {
    codeString: "B291;B271:2,4"
  },
  B493: {
    codeString: "B634;B270:4,-2"
  },
  B494: {
    codeString: "HW8N:0,12;HL8:0,14;HW8S:0,14;B695:0,6"
  },
  B495: {
    codeString: "HC4N:2,10;HL8:0,12;DL2-4S:0,12;HL4:2,16;DL2-4N:6,12"
  },
  B496: {
    codeString: "HC4N:0,8;HC4N:4,8;VL6:4,10"
  },
  B497: {
    codeString: "R48:0,8"
  },
  B498: {
    codeString: "B428;B428:2,0"
  },
  B499: {
    codeString: "HL12:0,8;VL8:0,8;RA8E:0,8;RA8W:8,8;VL8:12,8;HL12:0,16"
  },
  B500: {
    codeString: "B548;B513:2,0"
  },
  B501: {
    codeString: "B325;B281:2,0;B666:6,0"
  },
  B502: {
    codeString: "DOT:2,10;HL4:0,12;DOT:2,14"
  },
  B503: {
    codeString: "HW8E:0,8"
  },
  B504: {
    codeString: "B122;P4W:9,14",
    anchorOffsetX: -1.5
  },
  B505: {
    codeString: "B712;B313"
  },
  B506: {
    codeString: "QC4NW:4,8;HC4N:0,10;HC4N:4,10;HC8S:0,12;B528:3.5,0"
  },
  B507: {
    codeString: "QC4NW:3,4;VQW4NW:1,8;VQW4NE:3,8;HW4W:0,12;HW4E:5,12;HL4:1,16",
    anchorOffsetX: -0.5,
    anchorOffsetY: -4
  },
  B508: {
    codeString: "B801;C2:2,9;C2:2,13"
  },
  B509: {
    codeString: "DL8S:0,8"
  },
  B510: {
    codeString: "B434;P4W:3,12",
    anchorOffsetX: -0.5
  },
  B511: {
    codeString: "QC4NW:2,4;VL2:2,8;HC2N:0,9;HC2N:2,9;VL4:0,10;VL4:4,10;HC4S:0,14",
    anchorOffsetX: -1,
    anchorOffsetY: -4
  },
  B512: {
    codeString: "HL8:0,16;VL8:4,8"
  },
  B513: {
    codeString: "HL4:0,16;VL8:2,8"
  },
  B514: {
    codeString: "VL4:0,8;DL4S:0,12;HL4:0,16"
  },
  B515: {
    codeString: "HL8:0,16;VL4:8,12"
  },
  B516: {
    codeString: "RA8N:0,12;VL4:8,12"
  },
  B517: {
    codeString: "VL4:0,8;HL4:0,12;VL4:4,12"
  },
  B518: {
    codeString: "VL8:0,8;HL4:0,16"
  },
  B519: {
    codeString: "RA8E:0,8;HL4:0,16"
  },
  B520: {
    codeString: "OR84S:0,12;HL2:8,16;B695:10,4;B170:10,0"
  },
  B521: {
    codeString: "HC4S:0,8;HC4W:2,8;B122:4,0",
    anchorOffsetX: 2
  },
  B522: {
    codeString: "B156;P4S:6,5",
    anchorOffsetX: -1,
    anchorOffsetY: -3
  },
  B523: {
    codeString: "B1140;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B524: {
    codeString: "HL4:0,12;VL4:2,12"
  },
  B525: {
    codeString: "QC4NE:0,4;VL4:4,4;QC4NW:4,4;HC4N:2,8;VL4:2,10;VL4:6,10;HC4S:2,14",
    anchorOffsetY: -4
  },
  B526: {
    codeString: "B1086;P4W:13,12",
    anchorOffsetX: -1.5
  },
  B527: {
    codeString: "C4:0,12;HL8:2,12;HL8:2,16"
  },
  B528: {
    codeString: "HW2W:0,13;HW2E:0.5,13"
  },
  B529: {
    codeString: "B180;HL8:1,14"
  },
  B530: {
    codeString: "DL4S:0,8;OR48N:4,8;HC4E:8,10",
    anchorOffsetX: 1
  },
  B531: {
    codeString: "B281;P4S:2,14"
  },
  B532: {
    codeString: "B447;B840"
  },
  B533: {
    codeString: "B325;QC4NW:2,12",
    anchorOffsetX: -1
  },
  B534: {
    codeString: "B884;B688:10,0;HL6:12,16"
  },
  B535: {
    codeString: "HC4W:0,8;DC4:2,12;HC4E:6,8"
  },
  B536: {
    codeString: "B411;B281"
  },
  B537: {
    codeString: "B338;B528:1.5,0",
    anchorOffsetX: -1
  },
  B538: {
    codeString: "B411;P4W:9,6",
    anchorOffsetX: -1.5
  },
  B539: {
    codeString: "B878;B695"
  },
  B540: {
    codeString: "B559;B270:6,0",
    anchorOffsetX: -1
  },
  B541: {
    codeString: "B620;VL8:0,8;HL8:0,16"
  },
  B542: {
    codeString: "OR84N:0,12;DL4N:8,8",
    anchorOffsetX: -2
  },
  B543: {
    codeString: "HW2N:1,9.5;VL6:1,10;HL2:0,12;HL3:1,16;HC2E:4,14"
  },
  B544: {
    codeString: "DOT:0,16;DOT:4,12;DOT:4,16"
  },
  B545: {
    codeString: "B289;B105:4,0"
  },
  B546: {
    codeString: "B503;B341:4,0"
  },
  B547: {
    codeString: "B198;LARR4E:8,10",
    anchorOffsetX: -2
  },
  B548: {
    codeString: "RA8N:0,8"
  },
  B549: {
    codeString: "B1129;P4W:9,16"
  },
  B550: {
    codeString: "HL16:0,16;HL8:8,8;VL8:16,8"
  },
  B551: {
    codeString: "B559;B559:4,0"
  },
  B552: {
    codeString: "AT8N:0,8;DL8-4S:4,8;DL4N:8,12"
  },
  B553: {
    codeString: "B484;B699:3,0"
  },
  B554: {
    codeString: "B335:4,0;B335:0,4"
  },
  B555: {
    codeString: "DL4N:0,12;DLOC4SW:4,8;C4:4,8;SC4:4,8"
  },
  B556: {
    codeString: "B695;B271:2,0"
  },
  B557: {
    codeString: "C2:0,11;C2:2,10;C2:2,12;QC4NE:4,12",
    anchorOffsetX: -2
  },
  B558: {
    codeString: "RA8W:0,8"
  },
  B559: {
    codeString: "RA8E:0,8"
  },
  B560: {
    codeString: "B548;B513:6,0;B548:8,0"
  },
  B561: {
    codeString: "COMMA:0,12;COMMA:2,12"
  },
  B562: {
    codeString: "B313;B281"
  },
  B563: {
    codeString: "B428;B145:2,0",
    anchorOffsetX: 1
  },
  B564: {
    codeString: "B391;QC2SE:14,8",
    anchorOffsetX: -4
  },
  B565: {
    codeString: "B695:0,4;B357:2,0"
  },
  B566: {
    codeString: "RA8SW:0,8;RA2NE:0,14"
  },
  B567: {
    codeString: "C8:0,8;C4:2,10"
  },
  B568: {
    codeString: "B335;B695:0,4"
  },
  B569: {
    codeString: "B1148;P4S:2,13"
  },
  B570: {
    codeString: "HW4W:0,12;HL4:1,12;HL4:1,16;HW4E:5,12"
  },
  B571: {
    codeString: "B418;B700:0,4;B700:8,4",
    anchorOffsetX: -2
  },
  B572: {
    codeString: "OS8W:0,8"
  },
  B573: {
    codeString: "B1119;QC4SW:4,16"
  },
  B574: {
    codeString: "VL4:0,8;B239;VL4:8,8"
  },
  B575: {
    codeString: "VL8:0,8;DL4S:0,8;HL4:0,12"
  },
  B576: {
    codeString: "B170;DL4S:4,8"
  },
  B577: {
    codeString: "B265;QC4NE:4,12;QC4NW:8,12"
  },
  B578: {
    codeString: "HL4:0,10;HL4:0,14"
  },
  B579: {
    codeString: "DL12N:0,8;RA4SE:4,12;RA4SE:8,8"
  },
  B580: {
    codeString: "B447;B247"
  },
  B581: {
    codeString: "C4:0,12;VL8:4,8;C4:4,12"
  },
  B582: {
    codeString: "VL8:0,8;W8E:2,8;VL8:6,8"
  },
  B583: {
    codeString: "B291;B457:2,0"
  },
  B584: {
    codeString: "B281;DOT:2,18;DOT:6,18"
  },
  B585: {
    codeString: "DL8-4N:0,10;AT4N:2,12"
  },
  B586: {
    codeString: "C4:2,8;C4:0,12;C4:4,12;VL2:4,14;QC4SE:0,16"
  },
  B587: {
    codeString: "OS8S:0,8;HL8:0,12"
  },
  B588: {
    codeString: "B1006;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B589: {
    codeString: "B171;P4S:8,5",
    anchorOffsetY: -3
  },
  B590: {
    codeString: "HL4:0,8;VL6:2,8;HL4:0,14;HC4S:0,14"
  },
  B591: {
    codeString: "B572;B556"
  },
  B592: {
    codeString: "B171;P4W:13,10",
    anchorOffsetX: -1.5
  },
  B593: {
    codeString: "B291;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B594: {
    codeString: "B239;B271:2,4"
  },
  B595: {
    codeString: "B239;B695"
  },
  B596: {
    codeString: "B688;QC4SE:8,8",
    anchorOffsetX: -2
  },
  B597: {
    codeString: "HL8:0,8"
  },
  B598: {
    codeString: "B1084;OS4S:0,12"
  },
  B599: {
    codeString: "B291;B303:2,0"
  },
  B600: {
    codeString: "B473;B1154:0,2"
  },
  B601: {
    codeString: "HL8:0,16;HC4N:4,14;DL4N:8,12"
  },
  B602: {
    codeString: "HC4N:0,12;HC4S:4,14;HC4N:8,12"
  },
  B603: {
    codeString: "B602;B695:2,6"
  },
  B604: {
    codeString: "B695;VL6:4,8;B622:3,4"
  },
  B605: {
    codeString: "B604;P4W:6,14"
  },
  B606: {
    codeString: "B651:0,2;B651:4,-2"
  },
  B607: {
    codeString: "B548;B106:2,0"
  },
  B608: {
    codeString: "B278;B1154"
  },
  B609: {
    codeString: "B265;B695:4,0"
  },
  B610: {
    codeString: "B636;P4S:2,13"
  },
  B611: {
    codeString: "RA8SW:0,8;DL4N:0,12"
  },
  B612: {
    codeString: "W8S:0,11;HW4N:8,11;HW4S:8,12"
  },
  B613: {
    codeString: "C4:2,10;HC8N:0,12;HW4E:4,12"
  },
  B614: {
    codeString: "DL4N:0,12;DLOC4SW:4,8;C4:4,8"
  },
  B615: {
    codeString: "DL4-8S:0,8;HL4:4,16"
  },
  B616: {
    codeString: "B513;B548:2,0",
    anchorOffsetX: 1
  },
  B617: {
    codeString: "B482;B457"
  },
  B618: {
    codeString: "B1119;C8:0,8;C4:2,10"
  },
  B619: {
    codeString: "RA4NW:0,12;RA4NW:4,8"
  },
  B620: {
    codeString: "HL8:0,8;VL4:4,8;HL4:4,12;VL8:8,8"
  },
  B621: {
    codeString: "AT8N:0,8;AT8S:0,10"
  },
  B622: {
    codeString: "VL4:1,10;DC2:0,11"
  },
  B623: {
    codeString: "B695;B678:2,0"
  },
  B624: {
    codeString: "B572;B623"
  },
  B625: {
    codeString: "B325;P4W:3,12",
    anchorOffsetX: -0.5
  },
  B626: {
    codeString: "B393;B455:10,0",
    anchorOffsetX: 1
  },
  B627: {
    codeString: "B704;B312:8,0"
  },
  B628: {
    codeString: "B171;P4S:4,10"
  },
  B629: {
    codeString: "RT4SE:0,12"
  },
  B630: {
    codeString: "B291;B319:3,0"
  },
  B631: {
    codeString: "B161;DOT:1,12;DOT:3,12;DOT:2,13",
    anchorOffsetX: -2
  },
  B632: {
    codeString: "B1150;P4S:2,13"
  },
  B633: {
    codeString: "DOT:0,8;HL4:2,8;DOT:8,8;VL4:0,10;VL4:8,10;DOT:0,16;HL4:2,16;DOT:8,16"
  },
  B634: {
    codeString: "HL8:0,12"
  },
  B635: {
    codeString: "B1063;B335:4,0",
    anchorOffsetY: -2
  },
  B636: {
    codeString: "C8:0,8"
  },
  B637: {
    codeString: "B695:0,4;B1154"
  },
  B638: {
    codeString: "B851;W8W:7,8;DL2S:8,8",
    anchorOffsetX: -1
  },
  B639: {
    codeString: "OR84S:0,12"
  },
  B640: {
    codeString: "P4E:0,8;B124:3,0",
    anchorOffsetX: 2.5
  },
  B641: {
    codeString: "B201:0,-4;HL15:0,12;B700:3,0;B700:7,0;B700:11,0;DL2N:12,9;DL2S:13,10",
    anchorOffsetX: 1.5,
    anchorOffsetY: -4
  },
  B642: {
    codeString: "B473;B457"
  },
  B643: {
    codeString: "B108;HL4:0,12"
  },
  B644: {
    codeString: "B1121;B1121:4,0"
  },
  B645: {
    codeString: "B927;DOT:2,18"
  },
  B646: {
    codeString: "B270:0,2;B647:1,0",
    anchorOffsetX: 0.5
  },
  B647: {
    codeString: "DL2N:0,11"
  },
  B648: {
    codeString: "HW4W:0,12"
  },
  B649: {
    codeString: "B270;B270:2,0;RA4W:4,10",
    anchorOffsetX: -2
  },
  B650: {
    codeString: "RT4E:0,10"
  },
  B651: {
    codeString: "S4:0,10"
  },
  B652: {
    codeString: "B647;B270:3,-2",
    anchorOffsetX: -0.5
  },
  B653: {
    codeString: "B335;B428:4,0"
  },
  B654: {
    codeString: "P4E:0,10;B374:3,0",
    anchorOffsetX: 1.5
  },
  B655: {
    codeString: "C8:0,8;RA4SW:4,8"
  },
  B656: {
    codeString: "B700;P4W:5,12",
    anchorOffsetX: -1.5
  },
  B657: {
    codeString: "P4E:0,10;VL4:4,10",
    anchorOffsetX: -1
  },
  B658: {
    codeString: "B418;P4W:13,14",
    anchorOffsetX: -3.5
  },
  B659: {
    codeString: "B695:0,4;B212:2,0"
  },
  B660: {
    codeString: "B374;B651:2,0",
    anchorOffsetX: 1
  },
  B661: {
    codeString: "B291;P4S:2,5",
    anchorOffsetY: -3
  },
  B662: {
    codeString: "AT4S:0,12;VL2:2,10"
  },
  B663: {
    codeString: "VL2:2,6;VL2:6,6;S8:0,8;VL2:2,16;VL2:6,16",
    anchorOffsetY: -2
  },
  B664: {
    codeString: "B827;HL4:8,12;B700:8,0;DL2N:9,9;DL2S:10,10"
  },
  B665: {
    codeString: "RA2NE:0,14;HL8:2,16;RA2NW:10,14"
  },
  B666: {
    codeString: "QC4SE:0,8;VL8:4,8;QC4SW:4,8"
  },
  B667: {
    codeString: "B281;B700:2,0"
  },
  B668: {
    codeString: "B188;OS4S:0,8"
  },
  B669: {
    codeString: "B666;P4W:5,12"
  },
  B670: {
    codeString: "B447;B1048"
  },
  B671: {
    codeString: "B281;C4:2,16;B416:2,0"
  },
  B672: {
    codeString: "B122;HC8N:0,8;DL4N:8,8",
    anchorOffsetX: -2
  },
  B673: {
    codeString: "B447;B502:2,0"
  },
  B674: {
    codeString: "B548;VL6:4,8;HC4S:4,14"
  },
  B675: {
    codeString: "B607;B11:7,0;B500:8,0"
  },
  B676: {
    codeString: "B634;B270:4,2"
  },
  B677: {
    codeString: "VL4:2,10;P4E:0,10"
  },
  B678: {
    codeString: "LARR8N:0,8"
  },
  B679: {
    codeString: "DL8S:0,8;RA4NW:0,8"
  },
  B680: {
    codeString: "DL8N:0,8;RA4NE:4,8"
  },
  B681: {
    codeString: "B171;B314:4,-2"
  },
  B682: {
    codeString: "HW8W:0,8;HL8:2,8;HL2:2,16;HL2:8,16;HW8E:10,8;B314:4,-2;P4N:4,16"
  },
  B683: {
    codeString: "B1144;P4S:10,13"
  },
  B684: {
    codeString: "C4:2,12;B1119"
  },
  B685: {
    codeString: "QC4NW:4,12;B281;C4:2,16"
  },
  B686: {
    codeString: "B685;HW4W:3,16;HW4E:4,16"
  },
  B687: {
    codeString: "HC4N:2,8;VL4:2,10;VL4:6,10;HC4S:2,14;B1119"
  },
  B688: {
    codeString: "HL8:0,12;B700;B700:4,0"
  },
  B689: {
    codeString: "DL4S:0,8;B688:4,0",
    anchorOffsetX: 1.5
  },
  B690: {
    codeString: "B171:3,0;P4E:0,10;P4W:16,10"
  },
  B691: {
    codeString: "B572;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B692: {
    codeString: "DC2:0,8;VL8:1,8"
  },
  B693: {
    codeString: "B411;DL4N:8,12;DL8S:4,8"
  },
  B694: {
    codeString: "B939;B651:2,0"
  },
  B695: {
    codeString: "W8N:0,11"
  },
  B696: {
    codeString: "B636;B556"
  },
  B697: {
    codeString: "HL8:0,12;AT4N:2,12"
  },
  B698: {
    codeString: "B636;P4W:1,10"
  },
  B699: {
    codeString: "OC2SW:0,10;VL1:1,12;DOT:1,14"
  },
  B700: {
    codeString: "C4:0,12;DLIC4N:0,12;DLIC4S:0,12"
  },
  B701: {
    codeString: "B212;B700"
  },
  B702: {
    codeString: "B281;B561:3,0"
  },
  B703: {
    codeString: "B281;B699:3,0"
  },
  B704: {
    codeString: "B548;B710:6,0",
    anchorOffsetX: -1
  },
  B705: {
    codeString: "B114;B335:4,0",
    anchorOffsetX: -2
  },
  B706: {
    codeString: "B291;SC8:0,8"
  },
  B707: {
    codeString: "B291;VL8:2,8;VL8:6,8;HL8:0,10;HL8:0,14"
  },
  B708: {
    codeString: "QC4NE:0,8;QC4NW:4,8"
  },
  B709: {
    codeString: "B120:0,-4",
    anchorOffsetY: -2
  },
  B710: {
    codeString: "VL4:2,8;B314"
  },
  B711: {
    codeString: "B106;B106:0,-4"
  },
  B712: {
    codeString: "B597;B281"
  },
  B713: {
    codeString: "HL12:0,16;B602:0,4"
  },
  B714: {
    codeString: "B132;P4W:1,6",
    anchorOffsetY: -2
  },
  B715: {
    codeString: "B1135;P4S:10,13"
  },
  B716: {
    codeString: "LARRC8EC:0,8",
    anchorOffsetX: -1
  },
  B717: {
    codeString: "AA4S:0,8;HL4:0,12;HL4:0,14;VL4:2,12"
  },
  B718: {
    codeString: "B132;HC4N:0,10"
  },
  B719: {
    codeString: "B377;B106"
  },
  B720: {
    codeString: "VL8:4,8;DL4N:0,8;HL4:0,12"
  },
  B721: {
    codeString: "B170;DL4N:0,8"
  },
  B722: {
    codeString: "B695;B617:2,0"
  },
  B723: {
    codeString: "B678;B271:4,0"
  },
  B724: {
    codeString: "VL8:0,8;HW4N:0,7;HW4S:0,8;HW4S:0,16;VL8:4,8",
    anchorOffsetY: -1
  },
  B725: {
    codeString: "B313;B355",
    anchorOffsetY: -4
  },
  B726: {
    codeString: "B313;B247"
  },
  B727: {
    codeString: "B313;B733",
    anchorOffsetY: -4
  },
  B728: {
    codeString: "B513;B737:0,-2",
    anchorOffsetY: -2
  },
  B729: {
    codeString: "B708;B513:2,0"
  },
  B730: {
    codeString: "B246;B622:5,0"
  },
  B731: {
    codeString: "HC2W:0,14;HL8:1,14;HL8:1,16;HC2E:9,14"
  },
  B732: {
    codeString: "B570;HL6:0,14"
  },
  B733: {
    codeString: "B447:0,-4;B247",
    anchorOffsetY: -4
  },
  B734: {
    codeString: "P4W:0,10;B355:3,0;P4E:12,10",
    anchorOffsetY: -4
  },
  B735: {
    codeString: "B313;B894:2,0"
  },
  B736: {
    codeString: "B803;B513:2,0",
    anchorOffsetX: -2
  },
  B737: {
    codeString: "HC4S:0,8"
  },
  B738: {
    codeString: "HW4W:0,8;HW4E:3,8"
  },
  B739: {
    codeString: "B500;B548:8,0"
  },
  B740: {
    codeString: "B455;B548:8,0"
  },
  B741: {
    codeString: "B312;B548:8,0"
  },
  B742: {
    codeString: "B739;B622:11,0"
  },
  B743: {
    codeString: "B712;B303:2,0"
  },
  B744: {
    codeString: "HL12:0,10;VL6:0,10;VL2:10,12;HL8:2,14;VL6:12,10;HL12:0,16"
  },
  B745: {
    codeString: "W8E:0,8;W8W:6,8;HL6:1,16"
  },
  B746: {
    codeString: "B412;B699:3,0"
  },
  B747: {
    codeString: "RT8S:0,8;VL4:4,12;HL8:0,16"
  },
  B748: {
    codeString: "C8:0,8;B894:2,0"
  },
  B749: {
    codeString: "HL4:0,11;HL4:0,13;HC4N:2,8;VL4:2,10;HC4S:2,14",
    anchorOffsetX: 1
  },
  B750: {
    codeString: "B467;HL4:8,16;DL4-8S:6,8"
  },
  B751: {
    codeString: "B447;B106:2,0"
  },
  B752: {
    codeString: "HC8N:0,8;HL12:0,12",
    anchorOffsetX: -2
  },
  B753: {
    codeString: "B167;B457:2,0"
  },
  B754: {
    codeString: "HW8N:0,12;HL8:0,14;HW8S:0,14"
  },
  B755: {
    codeString: "HL4:0,8;VL8:0,8;VL8:2,8;VL8:4,8"
  },
  B756: {
    codeString: "B731:0,-4;B700:1,0;B700:5,0"
  },
  B757: {
    codeString: "B518:2,0;B700"
  },
  B758: {
    codeString: "B292;B335:8,0"
  },
  B759: {
    codeString: "C4:0,10;C4:3,10;C4:6,10"
  },
  B760: {
    codeString: "HC8E:0,8;LARR8E:0,10"
  },
  B761: {
    codeString: "B695:0,4;P4S:0,12"
  },
  B762: {
    codeString: "B720;P4W:5,12",
    anchorOffsetX: -1.5
  },
  B763: {
    codeString: "B720:1,0;P4N:0,13",
    anchorOffsetX: 0.5
  },
  B764: {
    codeString: "B170;P4S:5,9",
    anchorOffsetX: -0.5
  },
  B765: {
    codeString: "B170;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B766: {
    codeString: "P4E:0,10;B170:3,0",
    anchorOffsetX: 1.5
  },
  B767: {
    codeString: "B170;P4N:2,17"
  },
  B768: {
    codeString: "B170;P4N:2,13"
  },
  B769: {
    codeString: "B170;VL4:0,12"
  },
  B770: {
    codeString: "B695:0,4;DL4N:1,12;DL4N:3,14;DL2S:1,16;DL2S:5,12;DL5N:6,8"
  },
  B771: {
    codeString: "B695:0,4;DL4N:1,12;DL4N:3,14;DL2S:1,16;DL2S:5,12;DL2N:6,11;DL4N:7,6;DL4N:9,8;DL2S:7,10;DL2S:11,6",
    anchorOffsetY: -2
  },
  B772: {
    codeString: "B170;RA4NW:0,8"
  },
  B773: {
    codeString: "HC8N:0,4;B1040",
    anchorOffsetY: -4
  },
  B774: {
    codeString: "C8:0,4;OR42N:2,12",
    anchorOffsetY: -4
  },
  B775: {
    codeString: "B392;B270:4,0"
  },
  B776: {
    codeString: "B265;HC8N:4,12"
  },
  B777: {
    codeString: "DOT:0,10;DOT:0,14;DOT:4,10;DOT:4,14"
  },
  B778: {
    codeString: "S4:0,8;VL4:2,12"
  },
  B779: {
    codeString: "HC4N:0,8;VL4:0,10;VL4:4,10;HL4:0,14;VL2:2,14"
  },
  B780: {
    codeString: "B395;P4W:4,8",
    anchorOffsetX: -1
  },
  B781: {
    codeString: "R84:0,10;RA4E:0,10;RA4W:6,10"
  },
  B782: {
    codeString: "RT4E:0,10;S4:2,10;RT4W:6,10"
  },
  B783: {
    codeString: "LARRHC8NC:0,8;LARRHC8SC:2,12",
    anchorOffsetX: -2
  },
  B784: {
    codeString: "B450;B428:4,0"
  },
  B785: {
    codeString: "ARR4NW:0,8;ARR4SW:0,12;B428:4,0"
  },
  B786: {
    codeString: "B374;B457:2,0",
    anchorOffsetX: 1
  },
  B787: {
    codeString: "DL4S:0,8;DL4N:5,8;VL4:4,12;VL4:5,12"
  },
  B788: {
    codeString: "B630;P4S:2,5",
    anchorOffsetY: -3
  },
  B789: {
    codeString: "OS4N:0,12;HC4E:4,12",
    anchorOffsetX: -1
  },
  B790: {
    codeString: "OS4N:0,12;DL4N:4,8",
    anchorOffsetX: -2
  },
  B791: {
    codeString: "HL8:0,10;HC4N:2,8"
  },
  B792: {
    codeString: "HC4W:0,8;OS8N:2,8;HC4E:10,8"
  },
  B793: {
    codeString: "HL2:0,14;R84:2,12;HL2:10,14"
  },
  B794: {
    codeString: "B280;P4W:8,7",
    anchorOffsetX: -1
  },
  B795: {
    codeString: "B280;P4W:9,14",
    anchorOffsetX: -1.5
  },
  B796: {
    codeString: "B280:3,0;P4E:0,6",
    anchorOffsetX: 1.5
  },
  B797: {
    codeString: "B695:0,4;B456:8,0"
  },
  B798: {
    codeString: "OR84N:0,8;RA4S:0,8;RA4S:4,8"
  },
  B799: {
    codeString: "B281;B695:8,4;B281:16,0"
  },
  B800: {
    codeString: "HL12:0,12;C8:2,8"
  },
  B801: {
    codeString: "HW8W:0,8;HW8E:4,8"
  },
  B802: {
    codeString: "B447;B699:3,0"
  },
  B803: {
    codeString: "B447;LARR4E:8,10",
    anchorOffsetX: -2
  },
  B804: {
    codeString: "B377;B447"
  },
  B805: {
    codeString: "B1130;P4W:8,8",
    anchorOffsetX: -1
  },
  B806: {
    codeString: "B1131;P4W:9,15",
    anchorOffsetX: -1.5
  },
  B807: {
    codeString: "B321;QC2SW:8,12",
    anchorOffsetX: -1
  },
  B808: {
    codeString: "B1134;P4W:9,13",
    anchorOffsetX: -1.5
  },
  B809: {
    codeString: "B1133;P4W:9,15",
    anchorOffsetX: -1.5
  },
  B810: {
    codeString: "B123;QC2SW:8,12",
    anchorOffsetX: -1
  },
  B811: {
    codeString: "B566;P4N:2,17"
  },
  B812: {
    codeString: "B851;VL2:0,16;VL2:4,16;VL2:8,16"
  },
  B813: {
    codeString: "B447;HL4:2,12;AT4N:2,12"
  },
  B814: {
    codeString: "R84:0,10;VL4:4,10"
  },
  B815: {
    codeString: "B291;B723"
  },
  B816: {
    codeString: "B817;B548:8,0;HL8:8,16;VL8:12,8;VL4:16,12"
  },
  B817: {
    codeString: "B392;VL8:4,8"
  },
  B818: {
    codeString: "B321;VL4:0,8;VL4:8,8"
  },
  B819: {
    codeString: "B550;B191:8,0"
  },
  B820: {
    codeString: "B803;B451:2,0",
    anchorOffsetX: -2
  },
  B821: {
    codeString: "OR48N:0,8;RA4N:0,6",
    anchorOffsetY: -2
  },
  B822: {
    codeString: "B566:3,0;P4E:0,10",
    anchorOffsetX: 1.5
  },
  B823: {
    codeString: "B428;B120:2,0;B428:8,0"
  },
  B824: {
    codeString: "R84:0,10"
  },
  B825: {
    codeString: "RA4N:0,6;VL8:0,8;HL16:0,16;VL4:4,8;RA8N:4,8;VL4:12,8;RA4N:12,6;VL8:16,8"
  },
  B826: {
    codeString: "B447;B206:4,0"
  },
  B827: {
    codeString: "C8:0,8;DLIC8N:0,8;DLIC8S:0,8"
  },
  B828: {
    codeString: "B447;B829:3,0"
  },
  B829: {
    codeString: "VL2:1,10;C2:0,13"
  },
  B830: {
    codeString: "HL12:0,12;AA4N:4,12;AA4N:8,12;VL4:12,8;HL2:12,8",
    anchorOffsetX: 1
  },
  B831: {
    codeString: "LARR8W:0,10;VL4:8,8"
  },
  B832: {
    codeString: "B239;B829:3,0"
  },
  B833: {
    codeString: "HC4N:0,10;R84:0,12"
  },
  B834: {
    codeString: "B122;B845"
  },
  B835: {
    codeString: "B447;B678:2,0"
  },
  B836: {
    codeString: "LARRHC8NC:0,12",
    anchorOffsetX: -1
  },
  B837: {
    codeString: "B945;B433:2,0",
    anchorOffsetY: -4
  },
  B838: {
    codeString: "B945;B513:2,0",
    anchorOffsetY: -4
  },
  B839: {
    codeString: "B945;B710:2,0",
    anchorOffsetY: -4
  },
  B840: {
    codeString: "RT8N:0,12"
  },
  B841: {
    codeString: "B412;B270:4,0"
  },
  B842: {
    codeString: "HC4N:0,8;VL4:0,10;VL4:4,10;HC4S:0,14"
  },
  B843: {
    codeString: "B265;HL8:4,14"
  },
  B844: {
    codeString: "HL8:0,12;DL4S:0,12"
  },
  B845: {
    codeString: "DL2S:0,10;DL2S:2,10;DL2S:4,10"
  },
  B846: {
    codeString: "DL8-4N:0,12;HL4:8,12"
  },
  B847: {
    codeString: "B695:0,4;B366:4,0"
  },
  B848: {
    codeString: "B639;P4S:2,9"
  },
  B849: {
    codeString: "HL8:0,12;VL4:2,12;VL4:6,12;HL8:0,16"
  },
  B850: {
    codeString: "B391;DL2N:13,7",
    anchorOffsetX: -3.5
  },
  B851: {
    codeString: "HC8N:0,12;B695:0,4"
  },
  B852: {
    codeString: "B871;P4W:5,8",
    anchorOffsetX: -1.5
  },
  B853: {
    codeString: "B871;P4W:5,14",
    anchorOffsetX: -1.5
  },
  B854: {
    codeString: "HC8N:0,12"
  },
  B855: {
    codeString: "B856;P4W:9,12",
    anchorOffsetX: -1.5
  },
  B856: {
    codeString: "VL8:4,8;HW8N:0,12;HL8:0,14"
  },
  B857: {
    codeString: "VL6:2,8;VL8:4,8;VL6:6,8;HC4S:2,14;B281;C4:2,16"
  },
  B858: {
    codeString: "DOT:0,8;DOT:0,12;DOT:0,16;DOT:4,10;DOT:4,14;DOT:8,10;DOT:8,14;B695:6,0"
  },
  B859: {
    codeString: "OR84S:0,12;HC8S:0,12"
  },
  B860: {
    codeString: "B695;B939"
  },
  B861: {
    codeString: "B866;DOT:2,10;DOT:2,12"
  },
  B862: {
    codeString: "B527;DOT:6,14;DOT:8,14"
  },
  B863: {
    codeString: "B114;B695:2,0",
    anchorOffsetX: -1
  },
  B864: {
    codeString: "R84:0,10;VL4:2,10;VL4:4,10;VL4:6,10"
  },
  B865: {
    codeString: "B651;B462:2,0"
  },
  B866: {
    codeString: "VL8:0,8;VL8:4,8;C4:0,14"
  },
  B867: {
    codeString: "HL4:0,8;B866"
  },
  B868: {
    codeString: "B871;P4W:5,10",
    anchorOffsetX: -1.5
  },
  B869: {
    codeString: "QC4NW:0,12;HL2:4,12;QC4NW:2,12;HL2:0,16"
  },
  B870: {
    codeString: "B871;P4W:5,6",
    anchorOffsetX: -1.5,
    anchorOffsetY: -1
  },
  B871: {
    codeString: "HL4:0,8;HL4:0,10;HL4:0,12;HL4:0,14;HL4:0,16"
  },
  B872: {
    codeString: "VL8:0,8;P4W:1,8",
    anchorOffsetX: -1.5
  },
  B873: {
    codeString: "B856;P4W:5,8"
  },
  B874: {
    codeString: "B871;P4W:5,12",
    anchorOffsetX: -1.5
  },
  B875: {
    codeString: "B573;VL8:4,8"
  },
  B876: {
    codeString: "B736;LARR4W:14,10",
    anchorOffsetX: -5
  },
  B877: {
    codeString: "B597;B423;B281"
  },
  B878: {
    codeString: "OR84N:0,12"
  },
  B879: {
    codeString: "B391;P4W:9,14",
    anchorOffsetX: -3
  },
  B880: {
    codeString: "HC8W:0,8;HC4E:4,8;HC4E:4,12"
  },
  B881: {
    codeString: "B391;P4W:15,8",
    anchorOffsetX: -4.5
  },
  B882: {
    codeString: "B1128;P4W:7,10"
  },
  B883: {
    codeString: "P4W:0,10;B513:3,0;P4E:8,10"
  },
  B884: {
    codeString: "OR84S:0,12;HL4:8,16",
    anchorOffsetX: -2
  },
  B885: {
    codeString: "B803;B457:2,0",
    anchorOffsetX: -2
  },
  B886: {
    codeString: "B238;B2115:4,0",
    anchorOffsetY: -4
  },
  B887: {
    codeString: "LARROC8NWC:0,8",
    anchorOffsetX: 1
  },
  B888: {
    codeString: "B887;B281:2,0",
    anchorOffsetX: 1
  },
  B889: {
    codeString: "B1136;P4S:10,13"
  },
  B890: {
    codeString: "B695;HW4N:4,11"
  },
  B891: {
    codeString: "VL4:0,10;HL4:0,12"
  },
  B892: {
    codeString: "HL12:0,12;B700;B700:4,0;B700:8,0"
  },
  B893: {
    codeString: "B271:2,0;B281"
  },
  B894: {
    codeString: "C4:0,10;VL4:2,10"
  },
  B895: {
    codeString: "B635;VL8:12,8",
    anchorOffsetY: -2
  },
  B896: {
    codeString: "C8:0,8;B622:3,0"
  },
  B897: {
    codeString: "B447;B516"
  },
  B898: {
    codeString: "B438;DOT:2,12"
  },
  B899: {
    codeString: "R48:0,8;HL4:0,12"
  },
  B900: {
    codeString: "B280;P2SW:5,10"
  },
  B901: {
    codeString: "B291;B829:3,0"
  },
  B902: {
    codeString: "B86;B81:2,0",
    isIndicator: true,
    indicatorRole: 'adjectival',
    width: 4,
    name: "INDICATOR DESCRIPTION OF ACTION"
  },
  B903: {
    codeString: "HL2:0,5",
    isIndicator: true,
    indicatorRole: 'verbal',
    name: "INDICATOR CONTINUOUS"
  },
  B904: {
    codeString: "DL2N:0,4",
    isIndicator: true,
    indicatorRole: 'nominal',
    name: "INDICATOR DEFINITE"
  },
  // Not planned for Unicode
  B905: {
    codeString: "AT2N:0,4",
    isIndicator: true,
    indicatorRole: 'nominal',
    name: "INDICATOR FEMININE"
  },
  // Not planned for Unicode
  B906: {
    codeString: "VL2:0.5,4;HL1:0,6;DL.5N:0,4",
    isIndicator: true,
    indicatorRole: 'nominal',
    width: 1,
    name: "INDICATOR FIRST PERSON"
  },
  B907: {
    codeString: "VL1.25:0,4;DOT:0,6",
    isIndicator: true,
    indicatorRole: 'verbal',
    width: 0,
    name: "INDICATOR IMPERATIVE"
  },
  // Not planned for Unicode
  B908: {
    codeString: "DL2S:0,4",
    isIndicator: true,
    indicatorRole: 'nominal',
    name: "INDICATOR INDEFINITE"
  },
  // Not planned for Unicode
  B909: {
    codeString: "VL2:0,4",
    isIndicator: true,
    indicatorRole: 'nominal',
    width: 0,
    name: "INDICATOR NEUTER"
  },
  // Not planned for Unicode
  B910: {
    codeString: "P2E:0,4;VL2:2,4",
    isIndicator: true,
    indicatorRole: 'nominal',
    name: "INDICATOR DIRECT OBJECT"
  },
  B911: {
    codeString: "B92;B86:1.5,0",
    isIndicator: true,
    indicatorRole: 'adjectival',
    width: 3.5,
    name: "INDICATOR PAST PARTICIPLE"
  },
  B912: {
    codeString: "B92;B270:1.5,-8",
    isIndicator: true,
    indicatorRole: 'adjectival',
    width: 1.5,
    name: "INDICATOR PAST PERFECTIVE PARTICIPLE"
  },
  // Not planned for Unicode
  B913: {
    codeString: "SC2:0,4",
    isIndicator: true,
    indicatorRole: 'nominal',
    name: "INDICATOR POSSESSIVE"
  },
  B914: {
    codeString: "B928;B86:3,0",
    isIndicator: true,
    indicatorRole: 'adjectival',
    width: 5,
    name: "INDICATOR PRESENT PARTICIPLE"
  },
  // Not planned for Unicode
  B915: {
    codeString: "HC1N:0,4;DL1-1.5N:0,4.5;HL1:0,6",
    isIndicator: true,
    indicatorRole: 'nominal',
    width: 1,
    name: "INDICATOR SECOND PERSON"
  },
  // Not planned for Unicode
  B916: {
    codeString: "OC1SW:0,4;OC1NW:0,5",
    isIndicator: true,
    indicatorRole: 'nominal',
    width: 1,
    name: "INDICATOR THIRD PERSON"
  },
  B917: {
    codeString: "B239;LARR4E:8,10",
    anchorOffsetX: -2
  },
  B918: {
    codeString: "B239;HC2E:8,12",
    anchorOffsetX: -0.5
  },
  B919: {
    codeString: "QC4SW:0,12"
  },
  B920: {
    codeString: "B239;B271:2,0"
  },
  B921: {
    codeString: "HL8:0,12;C4:2,10"
  },
  B922: {
    codeString: "HW2E:0,11;HW4E:1,10;HW8E:1,8"
  },
  B923: {
    codeString: "P4S:0,9;B619:1,0",
    anchorOffsetX: 0.5
  },
  B924: {
    codeString: "B695;B325:2,0"
  },
  B925: {
    codeString: "C2:0,8;C8:1,8;C2:8,8;DOT:3,12;DOT:7,12;DOT:5,14"
  },
  B926: {
    codeString: "LARRHC8NCC:0,12",
    anchorOffsetX: 1
  },
  B927: {
    codeString: "B936;HL4:0,12"
  },
  B928: {
    codeString: "B92;B87:1.5,0",
    isIndicator: true,
    indicatorRole: 'verbal',
    name: "INDICATOR PRESENT"
  },
  B929: {
    codeString: "B335;B651:8,0",
    anchorOffsetX: 4
  },
  B930: {
    codeString: "B447;B319:3,0"
  },
  B931: {
    codeString: "B447;B303:2,0"
  },
  B932: {
    codeString: "B447;B660"
  },
  B933: {
    codeString: "HL4:0,12;DL4S:4,12"
  },
  B934: {
    codeString: "DC8:0,8;VL4:0,12;VL4:8,12"
  },
  B935: {
    codeString: "B335;B392:4,0",
    anchorOffsetX: 2
  },
  B936: {
    codeString: "HL4:0,8;VL8:2,8;HL4:0,16"
  },
  B937: {
    codeString: "B368:0,-4;HL4:0,12"
  },
  B938: {
    codeString: "B447;B2115:4,0"
  },
  B939: {
    codeString: "DL8N:0,8"
  },
  B940: {
    codeString: "B335;VL2:8,8;VL2:8,14"
  },
  B941: {
    codeString: "LARR4W:0,10;LARR4N:4,6;LARR4S:4,14;LARR4E:8,10",
    anchorOffsetY: -2
  },
  B942: {
    codeString: "C4:0,12;HC8N:2,8;C4:8,12"
  },
  B943: {
    codeString: "B335;VL2:4,8;VL2:4,14"
  },
  B944: {
    codeString: "B239;LARRHC8NC:4,10",
    anchorOffsetX: -3
  },
  B945: {
    codeString: "B597;B894:2,-6",
    anchorOffsetY: -4
  },
  B946: {
    codeString: "VL4:0,10;VL4:8,10"
  },
  B947: {
    codeString: "B239;HL8:0,12"
  },
  B948: {
    codeString: "B412;B335:4,0",
    anchorOffsetX: -2
  },
  B949: {
    codeString: "B239;B678:2,0"
  },
  B950: {
    codeString: "S8:0,8;VL8:2,8;VL8:4,8;VL8:6,8;HL8:0,10;HL8:0,12;HL8:0,14"
  },
  B951: {
    codeString: "B10:0,-4;DL4-8N:2,8;B11:6,0"
  },
  B952: {
    codeString: "HL4:0,8;HL4:0,16"
  },
  B953: {
    codeString: "HL4:0,16;B120:0,2"
  },
  B954: {
    codeString: "B447;B401:3,0;B401:5,0"
  },
  B955: {
    codeString: "B447;B401:4,0"
  },
  B956: {
    codeString: "HL4:0,12;VL4:2,12;HL4:0,16"
  },
  B957: {
    codeString: "HL4:0,12;HL4:0,16"
  },
  B958: {
    codeString: "W8W:0,8;VL8:1,8"
  },
  B959: {
    codeString: "B281;B107"
  },
  B960: {
    codeString: "B447;B653"
  },
  B961: {
    codeString: "B803;LARR4E:8,14",
    anchorOffsetX: -2
  },
  B962: {
    codeString: "B10:0,-4;DL4-8N:2,8;B13:6,0"
  },
  B963: {
    codeString: "B428;B428:4,0"
  },
  B964: {
    codeString: "B447;B10:1,0;VL8:4,8"
  },
  B965: {
    codeString: "VL4:0,10;HL4:0,12;VL4:4,10"
  },
  B966: {
    codeString: "B695;DOT:6,10;DOT:6,14;DOT:10,10;DOT:10,14;DOT:14,8;DOT:14,12;DOT:14,16"
  },
  B967: {
    codeString: "B377;HC4N:0,10"
  },
  B968: {
    codeString: "HL4:0,8;B368:0,-4"
  },
  B969: {
    codeString: "B484;B303:2,0"
  },
  B970: {
    codeString: "B313;B457:2,0"
  },
  B971: {
    codeString: "B411;B457:2,0"
  },
  B972: {
    codeString: "XA;XB:3.87;XC:7.75"
  },
  B973: {
    codeString: "B651;LARR4S:0,14"
  },
  B974: {
    codeString: "B700;B1154"
  },
  B975: {
    codeString: "B291;B313"
  },
  B976: {
    codeString: "B145;B291:4,0",
    anchorOffsetX: 2
  },
  B977: {
    codeString: "B291;B678:2,-4",
    anchorOffsetY: -4
  },
  B978: {
    codeString: "B163;HC2N:1,13;HC2N:5,13"
  },
  B979: {
    codeString: "P4W:0,10;B288:3,0;P4E:8,10"
  },
  B980: {
    codeString: "B651;P4W:5,10",
    anchorOffsetX: -1.5
  },
  B981: {
    codeString: "P4W:0,10;B982:3,0;P4E:12,10",
    anchorOffsetY: -1
  },
  B982: {
    codeString: "B814;HW2N:3,8.5;HW4N:2,7;HW2S:3,15;HW4S:2,16",
    anchorOffsetY: -1
  },
  B983: {
    codeString: "DL8-4N:0,8;DL8-4S:0,8;VL2:4,10"
  },
  B984: {
    codeString: "P4E:0,10;B651:3,0",
    anchorOffsetX: 1.5
  },
  B985: {
    codeString: "B447;B894:2,0"
  },
  B986: {
    codeString: "P4S:0,7;B651",
    anchorOffsetY: -1
  },
  B987: {
    codeString: "B428;B288:2,0;B428:8,0"
  },
  B988: {
    codeString: "RA4SW:0,12;DL8N:0,8;RA4NE:4,8"
  },
  B989: {
    codeString: "LARRHC8SCC:2,12;P4N:0,12"
  },
  B990: {
    codeString: "B651;P4N:0,15"
  },
  B991: {
    codeString: "B447;B288:2,0"
  },
  // Not planned for Unicode
  B992: {
    codeString: "HL2:0,4;VL2:1,4;HL2:0,6",
    isIndicator: true,
    indicatorRole: 'nominal',
    name: "INDICATOR DIMINUTIVE"
  },
  B993: {
    codeString: "HW8W:0,8;HL4:2,8;HL4:2,16;HW8E:6,8;DOT:4,12"
  },
  B994: {
    codeString: "B270;B1028:2,0",
    anchorOffsetX: 1
  },
  B995: {
    codeString: "W8E:0,4;B122:1,0",
    anchorOffsetX: 0.5,
    anchorOffsetY: -4
  },
  B996: {
    codeString: "VL4:0,10;DOT:2,16;DOT:4,16;DOT:6,16;P4E:8,10"
  },
  B997: {
    codeString: "B238;B449:2,0",
    anchorOffsetY: -4
  },
  B998: {
    codeString: "B148:2,0;B281"
  },
  B999: {
    codeString: "B216;C8:4,8",
    anchorOffsetX: 2
  },
  B1000: {
    codeString: "B939;B303:1,0",
    anchorOffsetX: -1
  },
  B1001: {
    codeString: "B153;B335:4,0"
  },
  B1002: {
    codeString: "B172;HL4:2,16;DOT:8,16"
  },
  B1003: {
    codeString: "B174;P4W:3,6",
    anchorOffsetX: -0.5,
    anchorOffsetY: -2
  },
  B1004: {
    codeString: "P4S:3,9;B180;P4N:3,17"
  },
  B1005: {
    codeString: "P4E:0,10;B518:3,0;P4W:4,10",
    anchorOffsetX: -0.5
  },
  B1006: {
    codeString: "B291;B651:2,0"
  },
  B1007: {
    codeString: "P4W:0,10;B394:2,0;P4E:10,10"
  },
  B1008: {
    codeString: "B335;B651:8,0;B145:12,0"
  },
  B1009: {
    codeString: "B239:0,-4"
  },
  B1010: {
    codeString: "B239:0,4"
  },
  B1011: {
    codeString: "B1094;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B1012: {
    codeString: "B447;B120:2,0"
  },
  B1013: {
    codeString: "B447;B449:2,0"
  },
  B1014: {
    codeString: "B710;B710:4,0"
  },
  B1015: {
    codeString: "B433;B433:4,0"
  },
  B1016: {
    codeString: "C4:0,8;DLOC4SE:0,8;SC4:0,8;DL4S:4,12;B555:4,0"
  },
  B1017: {
    codeString: "B278:2,0;B939"
  },
  B1018: {
    codeString: "B153;B145:4,0"
  },
  B1019: {
    codeString: "B335;B1063:8,0",
    anchorOffsetY: -2
  },
  B1020: {
    codeString: "VL8:0,8;P4S:0,14;VL8:4,8"
  },
  B1021: {
    codeString: "B236;B939:6,0",
    anchorOffsetX: 3
  },
  B1022: {
    codeString: "B428;B449:2,0;B428:8,0"
  },
  B1023: {
    codeString: "DL2-4N:0,8;DL2-4S:2,8;DL2-4S:0,12;DL2-4N:2,12"
  },
  B1024: {
    codeString: "B590:2,0;B281"
  },
  B1025: {
    codeString: "VL8:0,8;B829:3,0;VL8:8,8"
  },
  B1026: {
    codeString: "B712;B829:3,0"
  },
  B1027: {
    codeString: "B505;B939"
  },
  B1028: {
    codeString: "AA4S:0,12"
  },
  B1029: {
    codeString: "B920;P4N:2,8"
  },
  B1030: {
    codeString: "B319:3,0;B939"
  },
  B1031: {
    codeString: "P4S:0,7;B303;P4N:0,15",
    anchorOffsetY: -1
  },
  B1032: {
    codeString: "B303;P4N:0,15"
  },
  B1033: {
    codeString: "VL4:0,10;DOT:2,16;DOT:4,16;DOT:6,16;VL4:8,10"
  },
  B1034: {
    codeString: "P4E:0,10;B428:2,0;DOT:4,16;DOT:6,16;DOT:8,16;B428:10,0;P4W:10,10"
  },
  B1035: {
    codeString: "P4E:0,10;B428:2,0;B428:10,0;P4W:10,10"
  },
  B1036: {
    codeString: "B695:0,4;B239"
  },
  B1037: {
    codeString: "B325;P4W:5,8",
    anchorOffsetX: -1.5
  },
  B1038: {
    codeString: "B428;LARRQC4NEC:0,12;B634:0,4"
  },
  B1039: {
    codeString: "B695;B651:6,0"
  },
  B1040: {
    codeString: "B597;B271:2,0"
  },
  B1041: {
    codeString: "QC4NW:2,8;AT4S:0,12",
    anchorOffsetX: -1
  },
  B1042: {
    codeString: "B341;B699:2,0"
  },
  B1043: {
    codeString: "B238;B120:2,0",
    anchorOffsetY: -4
  },
  B1044: {
    codeString: "B281;B651:2,4"
  },
  B1045: {
    codeString: "B391;P4E:7,7",
    anchorOffsetX: -3,
    anchorOffsetY: -1
  },
  B1046: {
    codeString: "P4E:0,10;B391:3,0",
    anchorOffsetX: -1.5
  },
  B1047: {
    codeString: "B399;P4W:17,10",
    anchorOffsetX: -1.5
  },
  B1048: {
    codeString: "B247;B699:3,1"
  },
  B1049: {
    codeString: "VL4:0,12;HC8S:0,12;VL4:8,12"
  },
  B1050: {
    codeString: "B548;B341:2,0;B699:3,0"
  },
  B1051: {
    codeString: "HL4:0,8;VL8:4,8"
  },
  B1052: {
    codeString: "B418;P4W:7,10;P4S:10,13",
    anchorOffsetX: -3
  },
  B1053: {
    codeString: "B428;DOT:2,16;DOT:4,16;DOT:6,16;B428:8,0"
  },
  B1054: {
    codeString: "B1127;P4W:9,4",
    anchorOffsetY: -3
  },
  B1055: {
    codeString: "B335;B329:8,0;B145:12,0"
  },
  B1056: {
    codeString: "C8:0,8;DOT:2,12;DOT:6,12;HW4N:0,11;HW4S:0,12;HW4N:4,11;HW4S:4,12"
  },
  B1057: {
    codeString: "B335;B145:10,0"
  },
  B1058: {
    codeString: "B1057:0,-2;B1066:0,2"
  },
  B1059: {
    codeString: "B444:2,0;B708",
    anchorOffsetY: -4
  },
  B1060: {
    codeString: "VL4:0,10;VL4:4,10"
  },
  B1061: {
    codeString: "B423;B335:4,0",
    anchorOffsetX: -2
  },
  B1062: {
    codeString: "B457:2,0;B939"
  },
  B1063: {
    codeString: "B145:0,-4;B145:0,4",
    anchorOffsetY: -2
  },
  B1064: {
    codeString: "B171;B678:4,-4",
    anchorOffsetY: -4
  },
  B1065: {
    codeString: "B392;B270:10,0",
    anchorOffsetX: -1
  },
  B1066: {
    codeString: "B145;B335:10,0"
  },
  B1067: {
    codeString: "HC8N:0,4;B960",
    anchorOffsetY: -4
  },
  B1068: {
    codeString: "C8:0,8;DLIC8N:0,8;DLIC8S:0,8;VL8:4,8"
  },
  B1069: {
    codeString: "B449:0,-2;B120:0,2"
  },
  B1070: {
    codeString: "B120:0,2"
  },
  B1071: {
    codeString: "B548;B695:0,4"
  },
  B1072: {
    codeString: "B548;P4W:9,10",
    anchorOffsetX: -1.5
  },
  B1073: {
    codeString: "B651;LARR4E:4,10",
    anchorOffsetX: -2
  },
  B1075: {
    codeString: "C8:0,8;DOT:4,12"
  },
  B1076: {
    codeString: "B784;B447"
  },
  B1077: {
    codeString: "B517;B335:0,4"
  },
  B1078: {
    codeString: "HL4:0,8;VL8:0,8"
  },
  B1079: {
    codeString: "B392;B939"
  },
  B1080: {
    codeString: "VL4:0,12;P4S:0,14;VL4:4,12"
  },
  B1081: {
    codeString: "VL4:0,12;HL4:0,16;VL4:2,12;VL4:4,12"
  },
  B1082: {
    codeString: "B708;B148:2,0"
  },
  B1083: {
    codeString: "B517;B1084"
  },
  B1084: {
    codeString: "HL8:0,16;QC4SE:8,12"
  },
  B1085: {
    codeString: "B457:0,2;HL8:2,16;B319:9,0"
  },
  B1086: {
    codeString: "B457:0,2;HL10:2,16;VL4:8,12;B319:9,0;VL4:12,12"
  },
  B1087: {
    codeString: "HW8W:0,8;VL12:2,8;HL4:0,12;HW8E:2,8"
  },
  B1088: {
    codeString: "AA4N:0,8;B651:0,2"
  },
  B1089: {
    codeString: "B612;B939:6,0"
  },
  B1090: {
    codeString: "OC4NE:0,8;OC4NE:2,10;OC4NE:4,12"
  },
  B1091: {
    codeString: "B457;LARRQC4NEC:4,12",
    anchorOffsetX: -3
  },
  B1092: {
    codeString: "B615;B148:6,0"
  },
  B1093: {
    codeString: "B615;B263:6,0"
  },
  B1094: {
    codeString: "DS8:0,8"
  },
  B1095: {
    codeString: "B651;B695:2,0"
  },
  B1096: {
    codeString: "P4E:0,10;B428:2,0;B428:6,0;P4W:6,10"
  },
  B1097: {
    codeString: "B695:0,-4;B695;B695:0,4",
    anchorOffsetY: -1
  },
  B1098: {
    codeString: "B291:0,-4;B700;B700:4,0",
    anchorOffsetY: -4
  },
  B1099: {
    codeString: "B651:0,-2;B700"
  },
  B1100: {
    codeString: "B666;B939"
  },
  B1101: {
    codeString: "LARRHC8EC:0,8"
  },
  B1102: {
    codeString: "B676:0,4"
  },
  B1103: {
    codeString: "B335;B412:4,0",
    anchorOffsetX: 2
  },
  B1104: {
    codeString: "B428;LARRQC4NECC:0,10;B634:0,4"
  },
  B1105: {
    codeString: "S8:0,8;DC8:0,8;SC8:0,8"
  },
  B1106: {
    codeString: "QC4NW:0,12;QC4SE:0,12;B127:4,0",
    anchorOffsetX: 2
  },
  B1107: {
    codeString: "B281;B695"
  },
  B1108: {
    codeString: "B428;P4W:0,10;P4E:6,10;B428:8,0"
  },
  B1109: {
    codeString: "B239;DL4N:8,8",
    anchorOffsetX: -2
  },
  B1110: {
    codeString: "B710;P4W:4,12",
    anchorOffsetX: -1
  },
  B1111: {
    codeString: "B430;P4W:9,8",
    anchorOffsetX: -1.5
  },
  B1112: {
    codeString: "B710;B548:2,0;B710:8,0"
  },
  B1113: {
    codeString: "B433;B548:2,0;B433:8,0"
  },
  B1114: {
    codeString: "B1112;B622:5,0"
  },
  B1115: {
    codeString: "B1113;B622:5,0"
  },
  B1116: {
    codeString: "HL4:0,10;HL4:0,12;HL4:0,14"
  },
  B1117: {
    codeString: "B695:0,4"
  },
  B1118: {
    codeString: "B423;B281"
  },
  B1119: {
    codeString: "B281;QC4SE:0,16"
  },
  B1120: {
    codeString: "B616;B500:10,0",
    anchorOffsetX: 1
  },
  B1121: {
    codeString: "AT4S:0,12"
  },
  B1122: {
    codeString: "QC4NW:0,12;QC4SE:4,8"
  },
  B1123: {
    codeString: "B291;B145:4,0",
    anchorOffsetX: -2
  },
  B1124: {
    codeString: "B291;B271:2,-4",
    anchorOffsetY: -4
  },
  B1125: {
    codeString: "B291;B678:2,4"
  },
  B1126: {
    codeString: "DL2S:0,8;DL2N:0,10;DL2S:0,12;DL2N:0,14"
  },
  B1127: {
    codeString: "B171;B371:3.5,-4",
    anchorOffsetY: -2
  },
  B1128: {
    codeString: "B171;DOT:6,12"
  },
  B1129: {
    codeString: "B171;B371:3.5,6"
  },
  B1130: {
    codeString: "B392;HL8:0,12"
  },
  B1131: {
    codeString: "B392;VL2:0,16;HL8:0,18;VL2:8,16"
  },
  B1132: {
    codeString: "B392;VL4:8,8"
  },
  B1133: {
    codeString: "B392;VL2:0,16;VL2:8,16"
  },
  B1134: {
    codeString: "B392;HL8:0,14"
  },
  B1135: {
    codeString: "B392;HL8:8,16;VL4:16,12"
  },
  B1136: {
    codeString: "B392;B281:8,0;B392:16,0"
  },
  B1137: {
    codeString: "B325:2,0;B483"
  },
  B1138: {
    codeString: "B303;HL4:0,8"
  },
  B1139: {
    codeString: "B306;B371:1.5,6"
  },
  B1140: {
    codeString: "B306;DOT:7,12"
  },
  B1141: {
    codeString: "B371:1.5,0;B122"
  },
  B1142: {
    codeString: "B376;VL2:3,16;VL2:5,16"
  },
  B1143: {
    codeString: "B376;B371:1.5,-4",
    anchorOffsetY: -2
  },
  B1144: {
    codeString: "RT8SW:0,8;B281:8,0;B456:16,0"
  },
  B1145: {
    codeString: "B171;B271:4,4"
  },
  B1146: {
    codeString: "P4S:0,10"
  },
  B1147: {
    codeString: "RA2S:0,11"
  },
  B1148: {
    codeString: "HL16:0,16;B202:8,0"
  },
  B1149: {
    codeString: "B202;P4W:8,7",
    anchorOffsetX: -1
  },
  B1150: {
    codeString: "B281;B392:8,0"
  },
  B1151: {
    codeString: "B10:0,-4;DL4-8N:2,8;B12:6,0"
  },
  B1152: {
    codeString: "B11:0,-4;DL4-8N:2,8;B12:6,0"
  },
  B1153: {
    codeString: "B12:0,-4;DL4-8N:2,8;B13:6,0"
  },
  B1154: {
    codeString: "HL4:0,16"
  },
  B1155: {
    codeString: "B859;P4S:2,9"
  },
  B1156: {
    codeString: "B636;P3NE:3,10"
  },
  B1157: {
    codeString: "B636;P3NW:2,10"
  },
  B1158: {
    codeString: "B636;P3SE:3,11"
  },
  B1159: {
    codeString: "B636;P3SW:2,11"
  },
  B1160: {
    codeString: "B376;P4S:2,5",
    anchorOffsetY: -3
  },
  B1161: {
    codeString: "B303;B1154"
  },
  B1162: {
    codeString: "HL4:0,12;VL4:4,12;B335:4,0",
    anchorOffsetX: -2
  },
  B1163: {
    codeString: "LARR4W:0,10;LARR4E:4,10"
  },
  B1218: {
    codeString: "B335;B428:10,0",
    anchorOffsetX: -1
  },
  B1470: {
    codeString: "B513;B513:6,0"
  },
  B1525: {
    codeString: "B428;B335:2,0",
    anchorOffsetX: 1
  },
  B1999: {
    codeString: "VL2:2,6;R48:0,8;VL2:2,16",
    anchorOffsetY: -2
  },
  B2115: {
    codeString: "VL8:0,8;B11:2,0"
  },
  B2343: {
    codeString: "B10;VL8:4,8"
  },
  B5061: {
    codeString: "B335;B335:10,0"
  },
  B5640: {
    codeString: "B335;B940:10,0"
  },
  B5836: {
    codeString: "B428;B109:2,0",
    anchorOffsetX: -1
  },
  B5837: {
    codeString: "HC4N:0,8"
  },
  B5838: {
    codeString: "B5840:0,-1;B5840:0,3;B5840:4,-1;B5840:4,3"
  },
  B5839: {
    codeString: "B171;P4S:6,13"
  },
  B5840: {
    codeString: "C2:0,11"
  },
  B5841: {
    codeString: "B572;B191"
  },
  B5842: {
    codeString: "B629;B366:4,0"
  },
  B5843: {
    codeString: "B5844;VL6:3,8"
  },
  B5844: {
    codeString: "B106;B314:2,0"
  },
  B5995: {
    codeString: "B457;P4S:0,7",
    anchorOffsetY: -1
  },
  B5996: {
    codeString: "B99;B904:3,0",
    isIndicator: true,
    indicatorRole: 'nominal',
    width: 5,
    name: "INDICATOR DEFINITE PLURAL"
  },
  B5997: {
    codeString: "B97;B904:3,0",
    isIndicator: true,
    semanticIndicator: 'thing',
    indicatorRole: 'nominal',
    width: 5,
    name: "INDICATOR DEFINITE THING"
  },
  B5998: {
    codeString: "B97;B5996:3,0",
    isIndicator: true,
    semanticIndicator: 'thing',
    indicatorRole: 'nominal',
    width: 8,
    name: "INDICATOR DEFINITE PLURAL THING"
  },
  B5999: {
    codeString: "B956:0,2"
  },
  B6000: {
    codeString: "B314:0,2"
  },
  B6001: {
    codeString: "HL4:0,18;VL4:2,14"
  },
  B6002: {
    codeString: "B106:0,2"
  },
  B6003: {
    codeString: "B657:0,4",
    anchorOffsetX: -1
  },
  B6013: {
    codeString: "B696;LARR4E:8,10",
    anchorOffsetX: -2
  },
  B6015: {
    codeString: "B213;LARR4E:8,10",
    anchorOffsetX: -2
  },
  B6091: { // Temporarily removed from Blissary as its status for inclusion by BCI is unclear. Graphically, it's the opposite of COMPRESSION B1008.
    codeString: "B145;B651:8,0;B335:12,0"
  },
  B6106: {
    codeString: "HW8E:0,8;HL6:0,8;HL6:0,16;HW8W:4,8"
  },
  B6109: {
    codeString: "HW8W:0,8;HW8E:2,8"
  },
  B6168: {
    codeString: "B303;B651:4,0"
  },
  B6232: {
    codeString: "B917;B651:2,0",
    anchorOffsetX: -2
  },
  B6287: {
    codeString: "B700;HL8:2,12;HL8:2,16;B700:8,0"
  },
  B6300: {
    codeString: "B303;VL2:2,8;VL2:2,14;HL8:2,8;HL8:2,16;VL8:10,8",
    anchorOffsetX: 1
  },
  B6321: {
    codeString: "DL1N:0,8;VL4:1,8;DL1N:1,11;B968:3,0",
    anchorOffsetX: 1.5
  },
  B6393: {
    codeString: "P4S:0,7;B1116",
    anchorOffsetY: -1
  },
  B6414: {
    codeString: "DL8-4N:0,10"
  },
  B6415: {
    codeString: "DL8-4S:0,10"
  },
  B6420: {
    codeString: "DL4-8N:0,8"
  },
  B6435: {
    codeString: "HC8W:0,8;HW8W:2,8;B622:4,0"
  },
  B6436: {
    codeString: "HC2N:0,4",
    isIndicator: true,
    semanticIndicator: 'abstract',
    indicatorRole: 'nominal',
    name: "INDICATOR ABSTRACT"
  },
  B6437: {
    codeString: "B814;B695:6,0"
  },
  B6438: {
    codeString: "DL1N:0,8;VL4:1,8;DL1N:1,11;B937:3,0",
    anchorOffsetX: 1.5
  },
  B6439: {
    codeString: "P2E:0,4;B910:1.5",
    isIndicator: true,
    indicatorRole: 'nominal',
    name: "INDICATOR INDIRECT OBJECT",
    width: 3.5
  }
}

export { glyphData };